// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-25T19:52:29.941Z
// Property: Sorella (ID: 6767906449166454)
// Collections: 28 amenities, 21 floorplans (live), 65 photos, 51 POIs, 4 reviews, 9 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166454",
  "property_external_id": "txtsmm9",
  "property_zillow_url": "https://www.zillow.com/apartments/herriman-ut/sorella/CkNFkz/",
  "property_apartments_url": "https://www.apartments.com/sorella-herriman-ut/txtsmm9/",
  "property_google_business_url": "https://www.google.com/maps/place/Sorella/data=!4m2!3m1!1s0x0:0xa46a5964a9836dc8?sa=X&ved=2ahUKEwj8o5rv5KeSAxUWgFYBHchvGPAQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40243555623",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "1030SRLA",
  "property_status": null,
  "property_slug": "sorella",
  "property_name": "Sorella",
  "property_website_url": "https://www.liveatsorella.com/",
  "property_domain": "https://www.liveatsorella.com/",
  "property_address": "14352 South Via Molvero Way",
  "property_full_address": "14352 S Via Molvero Wy, Herriman, UT 84096, USA",
  "property_address_1": "14352 South Via Molvero Way",
  "property_address_2": null,
  "property_address_city": "Herriman",
  "property_address_state": "UT",
  "property_address_zip_full": null,
  "property_address_zip": "84096",
  "property_address_country": "US",
  "property_address_county": "Salt Lake County",
  "property_neighborhood_address": "Outer S Jordan/Riverton/Bluffdale",
  "property_address_latitude": "40.4911653",
  "property_address_longitude": "-111.987205",
  "property_email": null,
  "property_phone": "(385) 887-0598",
  "property_call_tracking_phone": "877-212-2649",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Sorella in Herriman, UT, your ideal home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans, featuring modern amenities like a heated pool, state-of-the-art fitness center, and stunning mountain views. Enjoy open-concept living with smart home features and luxurious finishes. Your oasis is just a click away!",
  "property_long_description": "Welcome to Sorella, where luxury meets comfort in the heart of Herriman, UT. Offering a diverse range of floor plans—one, two, and three-bedroom apartments—Sorella caters to your unique lifestyle. Experience open-concept living with spacious layouts that feature nine-foot ceilings, wood-style flooring, and plush carpeting throughout. Each home is designed for modern living with stainless steel appliances, quartz countertops, programmable thermostats, and energy-efficient features, ensuring you enjoy both style and functionality. \n\nStep outside your apartment and discover a wealth of amenities that elevate your living experience. Dive into relaxation with our sparkling, heated year-round pool and oversized resort-style spa. For fitness enthusiasts, our multi-level state-of-the-art fitness center is perfect for any workout routine. Enjoy gatherings with friends at the cozy fire pit area or unleash your competitive side in the game room. Our beautifully landscaped courtyards offer professional barbecue stations and ample seating, making them ideal for socializing in the fresh mountain air.\n\nPet owners will appreciate our pet-friendly community, complete with a pet wash station and large bike storage for your outdoor adventures. With covered parking options, spacious storage units available for rent, and attached or detached garage rentals, convenience is at your fingertips. \n\nDiscover the breathtaking mountain views and all the comfort that Sorella has to offer. Don’t miss out on finding your new home—browse our availability or schedule a tour today to experience our vibrant community firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6b9b-be1f-7666-8b95-f38cea875587.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a modern apartment building in the background.",
    "public_id": "019f6b9b-be1f-7666-8b95-f38cea875587",
    "storage_key": "property/6767906449166454/019f6b9b-be1f-7666-8b95-f38cea875587.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166454/019ffc3b-cc26-779a-8b57-fbcfe2621335.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3b-cc26-779a-8b57-fbcfe2621335",
    "storage_key": "property/6767906449166454/019ffc3b-cc26-779a-8b57-fbcfe2621335.m4v",
    "thumbnail_key": "property/6767906449166454/019ffc3b-cc26-779a-8b57-fbcfe2621335_thumb.webp",
    "size_bytes": 18116455,
    "classification": "Community",
    "title": "Modern Apartment Community Amenities & Interiors",
    "description": "Explore the luxurious amenities and stylish interiors of our apartment community, featuring a sparkling pool, state-of-the-art gym, and beautifully designed living spaces."
  },
  "property_total_units": "219",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "3",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "89.04109589041096",
  "property_admin_fee": "349",
  "property_application_fee": "65",
  "property_fees_deposit_info": "Security Deposit\n$200-1 Month (OAC)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "150",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Pets are welcome! Breed restrictions apply. ",
  "property_pet_policy_description": "One time pet fee: $350 for 1 pet, $400 for 2 pets. Refundable pet deposit: $150 for 1 pet, $200 for 2 pets. Monthly pet rent: $50 per pet\n\n",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://sorella.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcsorella",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-468d-77ee-95f3-856e5b97fe5f.webp",
  "property_primary_logo_media": {
    "alt_text": "SORELLA logo",
    "public_id": "019d02cf-468d-77ee-95f3-856e5b97fe5f",
    "storage_key": "property/6767906449166454/019d02cf-468d-77ee-95f3-856e5b97fe5f.webp",
    "width": 322,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-2d41-736c-80d7-09846b7eb1e6.webp",
  "property_secondary_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants.",
    "public_id": "019d02cf-2d41-736c-80d7-09846b7eb1e6",
    "storage_key": "property/6767906449166454/019d02cf-2d41-736c-80d7-09846b7eb1e6.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cc-8724-704f-9314-7cb2a6f60e7b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The property's logo.",
    "public_id": "019d02cc-8724-704f-9314-7cb2a6f60e7b",
    "storage_key": "property/6767906449166454/019d02cc-8724-704f-9314-7cb2a6f60e7b.webp",
    "width": 322,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-c67d-722b-8795-376b9beca8b8.webp",
  "property_mono_black_logo_media": {
    "alt_text": "SORELLA logo",
    "public_id": "019d594a-c67d-722b-8795-376b9beca8b8",
    "storage_key": "property/6767906449166454/019d594a-c67d-722b-8795-376b9beca8b8.webp",
    "width": 322,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "624 - 1227",
  "property_sqft_min": "624",
  "property_sqft_max": "1227",
  "property_price_range": null,
  "property_price_min": "1319",
  "property_price_max": null,
  "property_available_units": 24,
  "property_facebook_url": "https://www.facebook.com/Sorella.Apartments/",
  "property_instagram_url": "https://www.instagram.com/Sorella.Apartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJb1moOsmFUocRyG2DqWRZaqQ",
  "property_youtube_url": "https://www.youtube.com/watch?v=CsSX9v_Tz0A",
  "property_yelp_url": "https://www.yelp.com/biz/sorella-by-greystar-herriman",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sorella",
  "property_home_romance_title": "Experience Life Awaits You in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Sorella in Herriman, UT, where luxury meets comfort. Enjoy stunning mountain views from your spacious open-concept apartment, complete with modern finishes. Dive into our year-round heated pool, relax by the fire pit, or keep active in the state-of-the-art fitness center. Your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to Sorella, where Herriman living meets stylish comfort. With thoughtfully designed one, two, and three-bedroom floor plans, your ideal home awaits. Immerse yourself in a vibrant community filled with modern amenities. Browse our available apartment homes today and envision your future at Sorella!",
  "property_home_gallery_blurb": "Welcome to Sorella in Herriman, UT, where luxury meets comfort. With pet-friendly one to three-bedroom floor plans and resort-style amenities, like a year-round heated pool and a state-of-the-art fitness center, you’ll enjoy modern living with stunning mountain views. Picture yourself unwinding in spacious, stylish rooms with smart home features.",
  "property_home_neighborhood_blurb": "At Sorella in Herriman, UT, immerse yourself in a vibrant community that connects nature and convenience. Nestled near the serene Conservation Garden Park and a wealth of recreational options, each one, two, or three-bedroom apartment brings you just moments away from destinations like PEAK|45 and the dynamic Mountain View Village. Embrace a lifestyle where comfort meets adventure!",
  "property_home_reviews_blurb": "At Sorella Apartments in Herriman, UT, we pride ourselves on creating an extraordinary living experience. Our residents rave about our dedicated team, with one noting, \"Zeni goes above and beyond,\" ensuring every resident feels supported. With stunning interiors and a peaceful location, your perfect home awaits! See what our residents have to say!",
  "property_neighborhood_blurb": "Nestled in Herriman, Sorella offers effortless access to vibrant local highlights like Conservation Garden Park and Mountain View Village. Enjoy a day of adventure at The Cove at Herriman Springs or challenge your mind at Red Door Escape Room. Experience life redefined; your new neighborhood awaits by enjoying the unique attractions around you!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sorella in Herriman, UT, elevate your lifestyle with our year-round heated pool, resort-style spa, and a state-of-the-art fitness center. Each spacious apartment showcases designer kitchens and expansive ceilings. Perfect for the whole family—including your pets—our community offers beautiful courtyards, game rooms, and stunning mountain views. Experience comfort redefined!",
  "property_applynow_blurb": "At Sorella in Herriman, UT, luxury meets comfort with spacious one, two, and three-bedroom apartments. Revel in our resort-style amenities, from a sparkling heated pool to expansive fitness center. Enjoy breathtaking mountain views and modern living features that elevate your lifestyle. Your perfect home awaits—lease online today!",
  "property_contactus_blurb": "At Sorella in Herriman, UT, we offer a range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Each layout is tailored for comfort and style. Have questions? Our leasing team is ready to help you find your perfect space—reach out today!",
  "property_faqs_blurb": "At Sorella in Herriman, UT, our diverse floor plans—one, two, and three bedrooms—cater to every lifestyle. Have questions? Our FAQs page has the answers you seek, making your transition to our vibrant community seamless. Uncover the details that make Sorella the perfect place to call home!",
  "property_floorplans_blurb": "At Sorella in picturesque Herriman, UT, we offer thoughtfully designed floor plans to match your lifestyle—whether you seek the cozy embrace of a one-bedroom, the spacious comfort of a two-bedroom, or the grandeur of a three-bedroom home. Browse our options today and embark on your next adventure!",
  "property_gallery_blurb": "At Sorella in Herriman, UT, vibrant living comes alive in open-concept homes featuring stainless steel appliances and luxurious finishes. Enjoy year-round relaxation in our heated pool or cozy up by the fire pit. Picture yourself here, surrounded by breathtaking mountain views and an array of premium amenities tailored for you.",
  "property_interactivemap_blurb": "Welcome to Sorella in Herriman, UT, where modern living meets comfort. Choose from one, two, or three-bedroom layouts with stunning mountain views! Enjoy amenities like a year-round heated pool, a state-of-the-art fitness center, and cozy fire pit areas. Experience the perfect blend of luxury and convenience—your new home awaits!",
  "property_pets_blurb": "At Sorella in Herriman, UT, your furry companions are valued as family. Enjoy a vibrant community with pet-friendly amenities and trails just steps from your door. With a simple one-time fee and affordable monthly pet rent, living harmoniously with your pets has never been easier. Your adventure begins here!",
  "property_referafriend_blurb": "At Sorella in Herriman, UT, your ideal living space awaits with diverse floor plans, including one, two, and three-bedroom options. Make lasting memories in a vibrant community where great friends make great neighbors. Share the joy—refer a friend to Sorella today and let them experience home like never before!",
  "property_residentaccess_blurb": "At Sorella in Herriman, UT, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle needs. Enjoy easy access to our resident portal for seamless rent payments, maintenance requests, and community updates. Experience convenience and comfort, all within a vibrant community you’ll love calling home!",
  "property_reviews_blurb": "Nestled in serene Herriman, UT, Sorella Apartments offers residents a breathtaking living experience, highlighted by exceptional service. As one happy resident puts it, “I couldn’t have asked for a better experience.” With dedicated staff like Kori and Zeni, every detail is taken care of, ensuring a tranquil and enjoyable home.",
  "property_created_at": "1759782596597",
  "property_scheduletour_blurb": "At Sorella in Herriman, UT, we offer thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Experience our vibrant community and hear firsthand from residents who love calling Sorella home. Ready to find your perfect space? Schedule a tour today and envision your new beginning!",
  "property_thankyou_blurb": "Thank you for reaching out! At Sorella in Herriman, UT, we offer spacious one-, two-, and three-bedroom floor plans tailored to your lifestyle. Our dedicated team will connect with you soon to help you find your perfect home in our vibrant community. Stay tuned for exciting possibilities!",
  "property_virtualtours_blurb": "Welcome to Sorella in Herriman, UT, where modern living meets comfort. Our diverse floor plans, including one, two, and three-bedroom apartments, cater to your lifestyle needs. Experience the vibrant community and stylish interiors from the comfort of your home—take a virtual tour today and envision your new beginning!",
  "property_copyright": "2026 All Rights Reserved. Sorella",
  "property_seo_title_home": "Sorella | Luxury Apartments in Herriman, Utah",
  "property_seo_description_home": "Discover modern living at Sorella in Herriman, UT. Choose from luxury 1, 2, and 3-bedroom apartments with top amenities near Salt Lake City. Explore today!",
  "property_seo_title_floorplans": "Floor Plans | Luxury Herriman Apartments",
  "property_seo_description_floorplans": "Find your ideal living space at Sorella! Choose from stylish 1, 2, and 3-bedroom floor plans in Herriman, UT. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Luxury Apartments Herriman",
  "property_seo_description_amenities": "Elevate your lifestyle at Sorella in Herriman, UT! Enjoy bright apartments with modern amenities, including a fitness center, clubhouse, swimming pool, & more.",
  "property_seo_title_gallery": "Gallery | Luxury Apartments in Herriman, Utah",
  "property_seo_description_gallery": "Discover life at Sorella in Herriman, UT: spacious 1, 2, and 3-bedroom floor plans and modern amenities await!",
  "property_seo_title_virtualtours": "Virtual Tours | Luxury Apartments in Herriman, Utah",
  "property_seo_description_virtualtours": "Experience Sorella in Herriman, UT! Take a virtual tour of our spacious 1, 2, and 3-bedroom apartments tailored for your lifestyle.",
  "property_seo_title_interactivemap": "Interactive Map | Sorella Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Sorella in Herriman, UT! Explore our interactive map for one-to-three bedroom apartments and great amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Luxury Herriman, Utah Apartments",
  "property_seo_description_neighborhood": "Uncover Herriman's gems at Sorella near Salt Lake City. Live steps away from top entertainment, schools, dining, shopping, and more!",
  "property_seo_title_contact": "Contact Us | Apartments for Rent in Herriman, Utah",
  "property_seo_description_contact": "Experience the charm of Sorella in Herriman, UT. From cozy one-beds to spacious three-beds, our leasing team is ready to help. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Herriman, UT",
  "property_seo_description_faqs": "Find clarity at Sorella in Herriman, UT! Our FAQs cover everything from amenities to floor plans. Dive in and feel right at home with us today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Herriman, UT",
  "property_seo_description_reviews": "Experience the joys of Sorella in Herriman, UT! See what our residents say about spacious layouts, resort-style amenities, and scenic mountain views.",
  "property_seo_title_applynow": "Apply Now | Apartments in Herriman, UT",
  "property_seo_description_applynow": "Find your perfect space at Sorella in Herriman, UT! Enjoy luxurious amenities, various floor plans, and a vibrant community—your new home awaits. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Sorella",
  "property_seo_description_residentaccess": "Unlock convenience at Sorella in Herriman! Access your resident portal for easy rent payments, maintenance requests, and community updates—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Sorella",
  "property_seo_description_referafriend": "Refer a friend to Sorella in Herriman, UT! Enjoy the perks of great neighbors and vibrant living. Share the love and elevate your community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Luxury Apartments in Herriman, Utah",
  "property_seo_description_scheduletour": "Discover modern living at Sorella in Herriman, UT! Schedule a tour today to find your perfect apartment with stunning amenities!",
  "property_seo_title_privacy": "Privacy Policy | Sorella",
  "property_seo_description_privacy": "Your privacy matters at Sorella! Learn how we protect your information while you enjoy the best of Herriman, UT. View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Sorella",
  "property_seo_description_accessibility": "Discover seamless living at Sorella in Herriman, UT, where accessibility is key and every resident feels at home. Embrace inclusion with us!",
  "property_seo_title_sitemap": "Sitemap | Sorella",
  "property_seo_description_sitemap": "Uncover every corner of Sorella in Herriman, UT. Navigate our sitemap for a seamless journey to your dream home today!",
  "property_seo_title_thankyou": "Thank You | Sorella",
  "property_seo_description_thankyou": "Thank you for reaching out! Sorella in Herriman, UT awaits. Expect a team member to connect soon to discuss your future home and vibrant community life!",
  "property_seo_title_pets": "Pets | Pet Friendly Apartments in Herriman, UT",
  "property_seo_description_pets": "Sorella offers the best pet-friendly living in Herriman, UT. Check out our pet policy today and get one step closer to living with your furry friend.",
  "property_updated_at": "1786643208335",
  "amenities": [
    {
      "id": "custom_2d90d187-4ffd-48f4-8f55-0846b227b742",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Sparkling Heated Year Round Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_8f43c174-b0a2-4014-b9ef-47913217b0b7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Resort Style Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ccf96237-12d5-46c6-a99b-f754daf1f903",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking*",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_237cffdf-34bd-4893-82f6-4625d232f147",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Multi-Level State of the Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a0e66c8f-c59d-489e-bcf3-efe85256e82a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ecaeaea7-839b-4904-9595-9501f56aff85",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Cozy Fire Pit Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_34346b9e-7f2f-44f7-9724-a93c7f1c8b71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6c0f0f31-4ee3-4eb2-b2e9-5eef8b388da0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Fetch Package Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4118bf3c-4614-4e90-9be4-d574c5da0600",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Clubhouse Area’s Available to Rent",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b81c0353-701b-4fce-878a-ca2df126f7db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Large Bike Storage",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a17b0541-9be9-45a3-9432-abb9848ef4f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Beautiful courtyards with seating and barbecues",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_402babe5-3c7d-4e4d-9b04-366e8859a64e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Wash Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_64fc2d29-1124-4756-a2b3-57e3abc4ed65",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Open-Concept Living Areas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c65060ba-8403-42d4-ade3-b0e0c08ec113",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c3aabe23-14d2-442f-8ee0-244ea180e1de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b1e72ad0-46f9-4e80-9d45-89ccf3065464",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Programmable Thermostats and Lights",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9076d1c3-65ab-40db-a088-11a1cbd4356c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive 9 Foot and Vaulted Ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_be8da608-6d42-4389-b309-7609bd12bd31",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Distinctive Wood-Style Flooring and Plush Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_347d6e26-3c51-4e83-88bc-f2a794638560",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_98c26784-2a99-47c0-8b43-3c97f65ef851",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d41bc7d5-f072-4757-9515-d8b21dd30ee3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Large Walk In Closets*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5451a222-81a4-42f6-a198-dafc2ceb4ff2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5161c39a-2842-4354-8fac-ab80842a9db0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Faucets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_905190c5-81ca-4416-8aee-46ab2e3eee04",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_06f9b925-11cd-4abc-86a4-a2a9e2e54d4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Storages Available for Rent",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e53a72f2-3f32-40b4-beca-2655a41c41a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Home Integration",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6daa874d-e384-433f-a3d4-322db03bcfe9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Spectacular Mountain Views",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f7bfd0b1-7c2f-4d05-a0c1-075a69cdfdd1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "external_id": "false",
      "title": "Attached and Detached Garages Available for Rent",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_17255fb6-befa-424f-8494-e2ea32bd951b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-aeaf-721d-93f0-40be69cc9df1.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with mountains in the background.",
        "public_id": "019d5948-aeaf-721d-93f0-40be69cc9df1",
        "storage_key": "property/6767906449166454/019d5948-aeaf-721d-93f0-40be69cc9df1.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "An aerial view showcasing the modern architecture of an apartment complex against a backdrop of snow-capped mountains, featuring a covered parking area and outdoor seating.",
      "link": "",
      "alt_text": "Modern apartment building exterior with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/DJI_0297-256f7242.JPG"
    },
    {
      "id": "custom_81796d8f-896c-48c1-acda-e23caa683737",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-b855-72ae-85c3-537b8d600ede.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with colorful exteriors and balconies under a cloudy sky.",
        "public_id": "019d5948-b855-72ae-85c3-537b8d600ede",
        "storage_key": "property/6767906449166454/019d5948-b855-72ae-85c3-537b8d600ede.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Discover your new home at Sorella, offering modern living spaces and a vibrant community atmosphere. Now leasing!",
      "link": "",
      "alt_text": "Modern apartment buildings with colorful exteriors and balconies under a cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2828+of+39%29.jpg"
    },
    {
      "id": "custom_1c842623-172b-4d25-bdad-3c65c3066cf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-3241-70ae-981f-95c53b04b202.webp",
      "image_media": {
        "alt_text": "Garages at a multifamily property with blue and white exteriors.",
        "public_id": "019d5949-3241-70ae-981f-95c53b04b202",
        "storage_key": "property/6767906449166454/019d5949-3241-70ae-981f-95c53b04b202.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Secure your vehicle and belongings in our convenient garages, available for rent at our multifamily property.",
      "link": "",
      "alt_text": "Garages at a multifamily property with blue and white exteriors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2833+of+39%29.jpg"
    },
    {
      "id": "custom_0adf2533-89de-4c56-98b8-75a8c4c317a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-bafc-73eb-a03c-3dc0b36315f1.webp",
      "image_media": {
        "alt_text": "Modern living room with a fireplace and leather sofas.",
        "public_id": "019d5948-bafc-73eb-a03c-3dc0b36315f1",
        "storage_key": "property/6767906449166454/019d5948-bafc-73eb-a03c-3dc0b36315f1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern living room with a fireplace and leather sofas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Lobby.jpg"
    },
    {
      "id": "custom_a5ca3075-1ded-4c9c-9818-34f82702740f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-3b4c-734b-b8e9-3b819b70f2b1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with bar seating, coffee tables, and artwork.",
        "public_id": "019d5949-3b4c-734b-b8e9-3b819b70f2b1",
        "storage_key": "property/6767906449166454/019d5949-3b4c-734b-b8e9-3b819b70f2b1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a full-service bar, comfortable seating, and elegant decor.",
      "link": "",
      "alt_text": "Modern lounge area with bar seating, coffee tables, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Upstairs+Clubhouse.jpg"
    },
    {
      "id": "custom_217fcb3e-a5d2-4c80-9cd3-3db40a4ad32b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-ba60-756e-88bc-34e5c3846d8d.webp",
      "image_media": {
        "alt_text": "Stylish living room with black leather sofas, tan accent chairs, coffee table, and bar seating.",
        "public_id": "019d5948-ba60-756e-88bc-34e5c3846d8d",
        "storage_key": "property/6767906449166454/019d5948-ba60-756e-88bc-34e5c3846d8d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a modern and comfortable living space featuring sleek black leather sofas, unique tan accent chairs, and a chic bar area perfect for entertaining.",
      "link": "",
      "alt_text": "Stylish living room with black leather sofas, tan accent chairs, coffee table, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Clubhouse.jpg"
    },
    {
      "id": "custom_bbe3f161-4896-43bb-9450-175f4b0daf0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-bfd3-775a-bb5c-24ee7345ce86.webp",
      "image_media": {
        "alt_text": "Bar with stools and TVs in community lounge area",
        "public_id": "019d5948-bfd3-775a-bb5c-24ee7345ce86",
        "storage_key": "property/6767906449166454/019d5948-bfd3-775a-bb5c-24ee7345ce86.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stylish community lounge featuring a wet bar with bar stools and multiple televisions, perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Bar with stools and TVs in community lounge area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Game+Room+2.jpg"
    },
    {
      "id": "custom_1e6a69eb-4323-4f29-b080-5a2971e9de21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-cafe-704e-8996-b9f0265ef262.webp",
      "image_media": {
        "alt_text": "Modern lounge area with brick walls, featuring leather sofas, armchairs, a large ottoman coffee table, and a wall-mounted TV.",
        "public_id": "019d5948-cafe-704e-8996-b9f0265ef262",
        "storage_key": "property/6767906449166454/019d5948-cafe-704e-8996-b9f0265ef262.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, complete with comfortable seating, a large television, and a modern aesthetic.",
      "link": "",
      "alt_text": "Modern lounge area with brick walls, featuring leather sofas, armchairs, a large ottoman coffee table, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Game+Room.jpg"
    },
    {
      "id": "custom_bfe5e231-b412-4b05-9365-638e4869ddc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-c72b-70f6-8ccc-69d6ce38100a.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, bar, seating areas, and dining tables.",
        "public_id": "019d5948-c72b-70f6-8ccc-69d6ce38100a",
        "storage_key": "property/6767906449166454/019d5948-c72b-70f6-8ccc-69d6ce38100a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a pool table, a full-service bar, comfortable seating, and dining areas.",
      "link": "",
      "alt_text": "Community lounge with pool table, bar, seating areas, and dining tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Pool+Table.jpg"
    },
    {
      "id": "custom_87d40581-569c-4b2f-b5a6-b26f7e05120d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-cb6a-7785-8a90-cbf8b69c9df2.webp",
      "image_media": {
        "alt_text": "Indoor shuffleboard table with a view of the outdoor pool and apartment buildings.",
        "public_id": "019d5948-cb6a-7785-8a90-cbf8b69c9df2",
        "storage_key": "property/6767906449166454/019d5948-cb6a-7785-8a90-cbf8b69c9df2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Indoor shuffleboard table with a view of the outdoor pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Shuffle+Board.jpg"
    },
    {
      "id": "custom_79f42824-0a5c-46b9-b3b6-334f270ec798",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-c073-7153-9897-776c70c78089.webp",
      "image_media": {
        "alt_text": "Modern living room with sectional sofa, two leather chairs, and coffee table overlooking apartment buildings.",
        "public_id": "019d5949-c073-7153-9897-776c70c78089",
        "storage_key": "property/6767906449166454/019d5949-c073-7153-9897-776c70c78089.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in this stylish living room, featuring a comfortable sectional sofa, elegant leather armchairs, and a modern coffee table. Large windows offer scenic views of the surrounding community.",
      "link": "",
      "alt_text": "Modern living room with sectional sofa, two leather chairs, and coffee table overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2841+of+69%29.jpg"
    },
    {
      "id": "custom_4afd2549-229d-497f-a5fe-88117adb9832",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-4997-7061-93c0-83f35f542d8d.webp",
      "image_media": {
        "alt_text": "Community room with a large table and chairs, and a large window overlooking the building exterior and pool area.",
        "public_id": "019d5949-4997-7061-93c0-83f35f542d8d",
        "storage_key": "property/6767906449166454/019d5949-4997-7061-93c0-83f35f542d8d.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy our resident community room, perfect for gatherings or a quiet workspace, with a large table, chairs, and a view of the pool and exterior.",
      "link": "",
      "alt_text": "Community room with a large table and chairs, and a large window overlooking the building exterior and pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2844+of+69%29.jpg"
    },
    {
      "id": "custom_e9fa2ee9-921c-4ce5-86ac-e70f1cb8302d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-cee5-707e-9959-72e19837c442.webp",
      "image_media": {
        "alt_text": "Staircase with climbing mural and exercise equipment",
        "public_id": "019d5948-cee5-707e-9959-72e19837c442",
        "storage_key": "property/6767906449166454/019d5948-cee5-707e-9959-72e19837c442.webp",
        "width": 1920,
        "height": 2880
      },
      "title": "Community",
      "description": "Workout area with climbing mural and fitness equipment, featuring medicine balls, resistance bands, and yoga mats.",
      "link": "",
      "alt_text": "Staircase with climbing mural and exercise equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Fitness-+Lower+Level.jpg"
    },
    {
      "id": "custom_4eb70e5e-0f9a-4d8e-b25e-d33591b9795d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-d5c2-762c-9a81-e04a01150b7a.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, ellipticals, stair climber, and free weights.",
        "public_id": "019d5948-d5c2-762c-9a81-e04a01150b7a",
        "storage_key": "property/6767906449166454/019d5948-d5c2-762c-9a81-e04a01150b7a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of cardio and strength training equipment to help you achieve your fitness goals.",
      "link": "",
      "alt_text": "Modern fitness center with treadmills, ellipticals, stair climber, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Fitness+Center.jpg"
    },
    {
      "id": "custom_b2cbd827-771f-4945-8e36-22f4ffea3193",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-58a6-700e-84ac-ab950bf50112.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a modern fitness center.",
        "public_id": "019d5949-58a6-700e-84ac-ab950bf50112",
        "storage_key": "property/6767906449166454/019d5949-58a6-700e-84ac-ab950bf50112.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, elliptical machines, and weight training equipment.",
      "link": "",
      "alt_text": "Treadmills and elliptical machines in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2849+of+69%29.jpg"
    },
    {
      "id": "custom_8e4ba4e2-f370-4d7a-8d60-a93366dd1acb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-4e39-756c-ad2d-838ff99cf626.webp",
      "image_media": {
        "alt_text": "Fitness center with spin bikes, rowing machine, and mirrors, overlooking a pool area.",
        "public_id": "019d5949-4e39-756c-ad2d-838ff99cf626",
        "storage_key": "property/6767906449166454/019d5949-4e39-756c-ad2d-838ff99cf626.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and free weights. Step outside to relax by the sparkling pool.",
      "link": "",
      "alt_text": "Fitness center with spin bikes, rowing machine, and mirrors, overlooking a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Fitness+Center-+Lower+Level+Cardio.jpg"
    },
    {
      "id": "custom_1607fb2b-d700-436d-ac07-e9f3b33df44f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-5fa3-727f-8a83-ea8d67a9edf5.webp",
      "image_media": {
        "alt_text": "Dumbbells on a rack in a fitness center.",
        "public_id": "019d5949-5fa3-727f-8a83-ea8d67a9edf5",
        "storage_key": "property/6767906449166454/019d5949-5fa3-727f-8a83-ea8d67a9edf5.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "A selection of dumbbells are neatly arranged on a rack, ready for your workout in our on-site fitness center.",
      "link": "",
      "alt_text": "Dumbbells on a rack in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2852+of+69%29.jpg"
    },
    {
      "id": "custom_1a8c086f-8aa3-4d44-b20c-f3810bb846f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-615b-736a-98ec-99a4c6b9c253.webp",
      "image_media": {
        "alt_text": "Curled barbells on a rack in a gym.",
        "public_id": "019d5949-615b-736a-98ec-99a4c6b9c253",
        "storage_key": "property/6767906449166454/019d5949-615b-736a-98ec-99a4c6b9c253.webp",
        "width": 1920,
        "height": 1288
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring a variety of weights and exercise machines.",
      "link": "",
      "alt_text": "Curled barbells on a rack in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2851+of+69%29.jpg"
    },
    {
      "id": "custom_7086ffaa-dd46-4bbd-8bd9-c8ac722f4523",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-d9b0-71ef-b311-4a9cafba35a4.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight machines, and TVs.",
        "public_id": "019d5948-d9b0-71ef-b311-4a9cafba35a4",
        "storage_key": "property/6767906449166454/019d5948-d9b0-71ef-b311-4a9cafba35a4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines, weight-lifting equipment, and entertainment options.",
      "link": "",
      "alt_text": "Gym with cardio machines, weight machines, and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2855+of+69%29.jpg"
    },
    {
      "id": "custom_3b140606-b9a1-45ed-bf3d-7271f61e0cbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-da96-7384-a9bd-b24d01f9d157.webp",
      "image_media": {
        "alt_text": "Weight room with dumbbells, weight machines, and benches.",
        "public_id": "019d5948-da96-7384-a9bd-b24d01f9d157",
        "storage_key": "property/6767906449166454/019d5948-da96-7384-a9bd-b24d01f9d157.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Fully equipped fitness center with free weights and cardio machines for resident use.",
      "link": "",
      "alt_text": "Weight room with dumbbells, weight machines, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Fitness-+Free+Weights.jpg"
    },
    {
      "id": "custom_ead6f54e-1ec0-43f4-ba67-bb46f6312aa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-6fb2-743e-a29e-36cc84935da1.webp",
      "image_media": {
        "alt_text": "Treadmills and weight rack in a modern fitness center.",
        "public_id": "019d5949-6fb2-743e-a29e-36cc84935da1",
        "storage_key": "property/6767906449166454/019d5949-6fb2-743e-a29e-36cc84935da1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, stair climbers, and free weights.",
      "link": "",
      "alt_text": "Treadmills and weight rack in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2857+of+69%29.jpg"
    },
    {
      "id": "custom_da67d9b5-2f47-4b6f-b232-93311bc1aca0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-474d-70e5-9737-65395cc19401.webp",
      "image_media": {
        "alt_text": "Modern lounge area with bean bag chairs and a children's table, overlooking a fitness center.",
        "public_id": "019d5949-474d-70e5-9737-65395cc19401",
        "storage_key": "property/6767906449166454/019d5949-474d-70e5-9737-65395cc19401.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, complete with comfortable seating and a dedicated space for kids. Adjacent fitness center visible for your convenience.",
      "link": "",
      "alt_text": "Modern lounge area with bean bag chairs and a children's table, overlooking a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Kids+Play+Room-+Fitness+Center.jpg"
    },
    {
      "id": "custom_7bac6496-5275-4f2b-975b-290f32244c6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-dce2-77dc-bff3-dc500720bbcf.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and umbrellas in front of apartment building.",
        "public_id": "019d5948-dce2-77dc-bff3-dc500720bbcf",
        "storage_key": "property/6767906449166454/019d5948-dce2-77dc-bff3-dc500720bbcf.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax by our resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas. The perfect place to unwind after a long day.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and umbrellas in front of apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2820+of+69%29.jpg"
    },
    {
      "id": "custom_4d0ac679-03c7-402b-91b1-f9dfa71a3521",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-e38a-705f-9e2a-cc7261c9ef3c.webp",
      "image_media": {
        "alt_text": "Luxury apartment community with a pool and hot tub area.",
        "public_id": "019d5948-e38a-705f-9e2a-cc7261c9ef3c",
        "storage_key": "property/6767906449166454/019d5948-e38a-705f-9e2a-cc7261c9ef3c.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool and hot tub at this stunning multifamily property. Enjoy resort-style amenities and vibrant community living.",
      "link": "",
      "alt_text": "Luxury apartment community with a pool and hot tub area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2817+of+69%29.jpg"
    },
    {
      "id": "custom_7c057e1f-e2bf-4f61-9022-0324e209eb7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-e857-731e-9814-e04c67bbe0c5.webp",
      "image_media": {
        "alt_text": "Poolside lounge chairs and umbrellas with apartment building in the background.",
        "public_id": "019d5948-e857-731e-9814-e04c67bbe0c5",
        "storage_key": "property/6767906449166454/019d5948-e857-731e-9814-e04c67bbe0c5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and soak up the sun on our comfortable poolside lounge chairs, perfect for enjoying the amenities at our beautiful apartment community.",
      "link": "",
      "alt_text": "Poolside lounge chairs and umbrellas with apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2821+of+69%29.jpg"
    },
    {
      "id": "custom_28ee1ae4-99ad-4621-a35d-7631de5e8d44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-731b-74b7-8399-1d84be35e741.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex with a swimming pool and hot tub.",
        "public_id": "019d5949-731b-74b7-8399-1d84be35e741",
        "storage_key": "property/6767906449166454/019d5949-731b-74b7-8399-1d84be35e741.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool and relax in the bubbling hot tub. Perfect for unwinding after a long day or soaking up the sun.",
      "link": "",
      "alt_text": "Luxury apartment complex with a swimming pool and hot tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Hot+Tub.jpg"
    },
    {
      "id": "custom_7a43eae4-c346-4962-a97f-c5c84c58b11c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-e89c-73ad-b913-fd45ea6861c0.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with a modern apartment building in the background.",
        "public_id": "019d5948-e89c-73ad-b913-fd45ea6861c0",
        "storage_key": "property/6767906449166454/019d5948-e89c-73ad-b913-fd45ea6861c0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor pool, surrounded by the sleek architecture of our community.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with a modern apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Pool-+C+Building.jpg"
    },
    {
      "id": "custom_9940580c-a28a-45f5-92b4-eb70a2eb07c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-f0cd-77df-a49e-d8dc5b96bb46.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with built-in grills and pool area",
        "public_id": "019d5948-f0cd-77df-a49e-d8dc5b96bb46",
        "storage_key": "property/6767906449166454/019d5948-f0cd-77df-a49e-d8dc5b96bb46.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and relaxation with our spacious outdoor kitchen featuring multiple grills, perfect for entertaining by the pool.",
      "link": "",
      "alt_text": "Outdoor kitchen with built-in grills and pool area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Grills.jpg"
    },
    {
      "id": "custom_6af956f7-e7ea-41b7-8961-771a2508d60e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5948-f0cd-77df-a49e-dd72f17927e4.webp",
      "image_media": {
        "alt_text": "Outdoor patio with sectional sofa, chairs, and fire pit.",
        "public_id": "019d5948-f0cd-77df-a49e-dd72f17927e4",
        "storage_key": "property/6767906449166454/019d5948-f0cd-77df-a49e-dd72f17927e4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind on the outdoor patio, complete with comfortable seating and a modern fire pit.",
      "link": "",
      "alt_text": "Outdoor patio with sectional sofa, chairs, and fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Fire+Pit.jpg"
    },
    {
      "id": "custom_893572e9-1c3b-4fb4-83d2-a325e69ff069",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-020f-72bf-9931-a3b6be357776.webp",
      "image_media": {
        "alt_text": "Modern outdoor patio with grey sectional sofas, armchairs, and coffee tables.",
        "public_id": "019d5949-020f-72bf-9931-a3b6be357776",
        "storage_key": "property/6767906449166454/019d5949-020f-72bf-9931-a3b6be357776.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the outdoors on our spacious patio, perfect for relaxing or socializing with comfortable seating and scenic views.",
      "link": "",
      "alt_text": "Modern outdoor patio with grey sectional sofas, armchairs, and coffee tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2835+of+69%29.jpg"
    },
    {
      "id": "custom_6d03202e-3a61-4897-9e7e-dbf729bf9a6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-8981-7610-8a29-86e048c29d29.webp",
      "image_media": {
        "alt_text": "Hallway with wall-mounted bike racks and charging stations",
        "public_id": "019d5949-8981-7610-8a29-86e048c29d29",
        "storage_key": "property/6767906449166454/019d5949-8981-7610-8a29-86e048c29d29.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Secure bike storage with convenient charging stations available for residents.",
      "link": "",
      "alt_text": "Hallway with wall-mounted bike racks and charging stations",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2868+of+69%29.jpg"
    },
    {
      "id": "custom_cd9daefb-b5b2-4110-800a-ee431e566737",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-0233-74a1-8913-0a89b869c6bc.webp",
      "image_media": {
        "alt_text": "Community room with a long table, stools, and charging stations.",
        "public_id": "019d5949-0233-74a1-8913-0a89b869c6bc",
        "storage_key": "property/6767906449166454/019d5949-0233-74a1-8913-0a89b869c6bc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "A versatile community space featuring a communal table, bar stools, and convenient charging stations, perfect for residents to gather and connect.",
      "link": "",
      "alt_text": "Community room with a long table, stools, and charging stations.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Bike+Room.jpg"
    },
    {
      "id": "custom_38be2652-91c5-431e-85ed-4d0942f1e11b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-8c84-7490-9761-22615371ad40.webp",
      "image_media": {
        "alt_text": "Pet grooming station with stainless steel tub and ramp.",
        "public_id": "019d5949-8c84-7490-9761-22615371ad40",
        "storage_key": "property/6767906449166454/019d5949-8c84-7490-9761-22615371ad40.webp",
        "width": 1920,
        "height": 2882
      },
      "title": "Community",
      "description": "Groom your furry friends at our convenient pet grooming station. Featuring a raised tub, ramp access, and easy-to-clean surfaces.",
      "link": "",
      "alt_text": "Pet grooming station with stainless steel tub and ramp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Dog+Wash.jpg"
    },
    {
      "id": "custom_56dd8a3f-333c-4cd6-aeea-60010e3bafd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-8e18-7725-9beb-bd56f6aa7a62.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a view into a pantry with a washer and dryer.",
        "public_id": "019d5949-8e18-7725-9beb-bd56f6aa7a62",
        "storage_key": "property/6767906449166454/019d5949-8e18-7725-9beb-bd56f6aa7a62.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a view into a pantry with a washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2830+of+69%29.jpg"
    },
    {
      "id": "custom_d052723e-b496-441f-bcf9-95f7f618fc1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-8ec3-728b-a124-3823643cf1f5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large island, stainless steel appliances, and contemporary cabinetry.",
        "public_id": "019d5949-8ec3-728b-a124-3823643cf1f5",
        "storage_key": "property/6767906449166454/019d5949-8ec3-728b-a124-3823643cf1f5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this stylish, modern kitchen featuring a spacious island perfect for casual dining, sleek stainless steel appliances, and ample cabinetry for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with a large island, stainless steel appliances, and contemporary cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/1x1+model+kitchen.jpg"
    },
    {
      "id": "custom_3616f077-3e41-4ef4-95e4-e787a02d7fbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-0604-72ef-b31c-9ead59995a68.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a sofa, coffee table, TV, dining table, and chairs.",
        "public_id": "019d5949-0604-72ef-b31c-9ead59995a68",
        "storage_key": "property/6767906449166454/019d5949-0604-72ef-b31c-9ead59995a68.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Stylish and spacious living and dining area featuring a comfortable sofa, modern coffee table, wall-mounted TV, and an elegant dining set.",
      "link": "",
      "alt_text": "Living room and dining area with a sofa, coffee table, TV, dining table, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%283+of+39%29.jpg"
    },
    {
      "id": "custom_4c3f0ba1-35b4-4a23-b977-26c4f393bc2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-a512-736e-8d54-b603cdf81ed0.webp",
      "image_media": {
        "alt_text": "Modern living and dining room with large abstract art and mountain view.",
        "public_id": "019d5949-a512-736e-8d54-b603cdf81ed0",
        "storage_key": "property/6767906449166454/019d5949-a512-736e-8d54-b603cdf81ed0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern living and dining room with large abstract art and mountain view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+living+room.jpg"
    },
    {
      "id": "custom_90b1eef9-0468-4775-a784-f40f5ce843dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-a810-725c-b6fb-be575b0e8e83.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and window.",
        "public_id": "019d5949-a810-725c-b6fb-be575b0e8e83",
        "storage_key": "property/6767906449166454/019d5949-a810-725c-b6fb-be575b0e8e83.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant dresser, and large window with a view.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/1x1+model+bedroom.jpg"
    },
    {
      "id": "custom_80704903-b216-4746-a79a-3cfca5337ef9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-0789-7363-915b-92d91159aa3b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019d5949-0789-7363-915b-92d91159aa3b",
        "storage_key": "property/6767906449166454/019d5949-0789-7363-915b-92d91159aa3b.webp",
        "width": 1920,
        "height": 2880
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a dark wood vanity, sleek fixtures, and a clean white tub with a textured shower curtain. Perfect for relaxing.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+2nd+bath.jpg"
    },
    {
      "id": "custom_d44cfbf7-0df4-4eae-b7a8-adddb70ee8e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-a776-70e9-96d0-f11045094392.webp",
      "image_media": {
        "alt_text": "Washer and dryer with shelves and decor in a laundry room.",
        "public_id": "019d5949-a776-70e9-96d0-f11045094392",
        "storage_key": "property/6767906449166454/019d5949-a776-70e9-96d0-f11045094392.webp",
        "width": 1920,
        "height": 2880
      },
      "title": "Apartment",
      "description": "A clean and organized laundry room featuring a white washer and dryer set, ample shelving for storage, and decorative baskets and vases.",
      "link": "",
      "alt_text": "Washer and dryer with shelves and decor in a laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/1x1+model+laundry.jpg"
    },
    {
      "id": "custom_ad754176-8170-47ed-9ffc-c40bf814c8ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-bdf3-75ab-900a-c9d9a315057a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with stools.",
        "public_id": "019d5949-bdf3-75ab-900a-c9d9a315057a",
        "storage_key": "property/6767906449166454/019d5949-bdf3-75ab-900a-c9d9a315057a.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2812+of+69%29.jpg"
    },
    {
      "id": "custom_f3e1c48f-8bc0-47e5-9f5d-e8e222e67b03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-f527-73ec-9741-0a108dff32dd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d5949-f527-73ec-9741-0a108dff32dd",
        "storage_key": "property/6767906449166454/019d5949-f527-73ec-9741-0a108dff32dd.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark wood cabinetry, stainless steel appliances, and a spacious island perfect for meal prep and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%281+of+69%29.jpg"
    },
    {
      "id": "custom_70b00337-ac5c-4242-b57d-6fac918cd9ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-bee3-773e-9add-7c464b2ab6cf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island, and open-concept living space.",
        "public_id": "019d5949-bee3-773e-9add-7c464b2ab6cf",
        "storage_key": "property/6767906449166454/019d5949-bee3-773e-9add-7c464b2ab6cf.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and contemporary kitchen featuring a large island with a sink and dishwasher, seamlessly flowing into a comfortable living area with ample natural light.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, island, and open-concept living space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2824+of+69%29.jpg"
    },
    {
      "id": "custom_803d7ba5-165e-4daa-81bb-74b3ddf3b8bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-106d-76af-8612-b97ab10b1e0b.webp",
      "image_media": {
        "alt_text": "Modern living room with contemporary furniture, including a sofa, coffee table, accent chairs, and a ceiling fan.",
        "public_id": "019d5949-106d-76af-8612-b97ab10b1e0b",
        "storage_key": "property/6767906449166454/019d5949-106d-76af-8612-b97ab10b1e0b.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment. The spacious living area features stylish furniture, a ceiling fan, and large windows with scenic views.",
      "link": "",
      "alt_text": "Modern living room with contemporary furniture, including a sofa, coffee table, accent chairs, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2825+of+69%29.jpg"
    },
    {
      "id": "custom_3c595f5c-a018-4ed7-93e6-e9532b327bfb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-1088-715e-b7a7-87032bbdd470.webp",
      "image_media": {
        "alt_text": "Living room with a modern armchair, black shelving unit with decor, and a round coffee table.",
        "public_id": "019d5949-1088-715e-b7a7-87032bbdd470",
        "storage_key": "property/6767906449166454/019d5949-1088-715e-b7a7-87032bbdd470.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into the spacious living area, featuring a stylish armchair, an elegant shelving unit, and a chic coffee table. Enjoy an open-concept design that flows into a modern kitchen.",
      "link": "",
      "alt_text": "Living room with a modern armchair, black shelving unit with decor, and a round coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/1x1+model+living+room.jpg"
    },
    {
      "id": "custom_d76ad67b-e911-4250-b5ec-a886cb921b88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-568a-7344-8495-31658c5cac1d.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, chairs, and a view of the exterior.",
        "public_id": "019d02cf-568a-7344-8495-31658c5cac1d",
        "storage_key": "property/6767906449166454/019d02cf-568a-7344-8495-31658c5cac1d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a unique wooden coffee table, and accent chairs, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, chairs, and a view of the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/1x1+model.jpg"
    },
    {
      "id": "custom_132596e3-eed5-4b42-815b-50a92cca64b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-da47-76b9-8b84-06e1e09f1df6.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and closet.",
        "public_id": "019d5949-da47-76b9-8b84-06e1e09f1df6",
        "storage_key": "property/6767906449166454/019d5949-da47-76b9-8b84-06e1e09f1df6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstand, and a convenient walk-in closet. The room is well-lit and offers a serene atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2826+of+69%29.jpg"
    },
    {
      "id": "custom_85468e4b-f790-4188-a50a-deed9c09b5ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-dadc-7046-b5e9-36645e39c712.webp",
      "image_media": {
        "alt_text": "Modern bathroom with wood vanity, white countertop, sink, mirror, and shower/tub combo.",
        "public_id": "019d5949-dadc-7046-b5e9-36645e39c712",
        "storage_key": "property/6767906449166454/019d5949-dadc-7046-b5e9-36645e39c712.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed apartment bathroom, featuring a sleek wood vanity, modern fixtures, and a relaxing shower and tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with wood vanity, white countertop, sink, mirror, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+MR+%288+of+69%29.jpg"
    },
    {
      "id": "custom_6061b8fa-6d74-422a-bda6-7ad69f7cd976",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-dc90-7777-9f31-b605636fdf44.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and an ensuite bathroom visible through an open door.",
        "public_id": "019d5949-dc90-7777-9f31-b605636fdf44",
        "storage_key": "property/6767906449166454/019d5949-dc90-7777-9f31-b605636fdf44.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-size bed and a spacious ensuite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and an ensuite bathroom visible through an open door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2824+of+39%29.jpg"
    },
    {
      "id": "custom_331094bc-5096-4bfb-b263-197ffefe9ad4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-de03-71ec-87a4-84235ac61c7c.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and walk-in closet.",
        "public_id": "019d5949-de03-71ec-87a4-84235ac61c7c",
        "storage_key": "property/6767906449166454/019d5949-de03-71ec-87a4-84235ac61c7c.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern wood vanity with ample storage, a sleek countertop, and a large vanity mirror. Includes a toilet and a walk-in closet with shelving.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2814+of+69%29.jpg"
    },
    {
      "id": "custom_cc7c57d5-6dfe-4799-a973-f6141eb0d2e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-eb99-74be-b5c3-2cd94b5ec91d.webp",
      "image_media": {
        "alt_text": "Walk-in closet with built-in shelves and hanging rods",
        "public_id": "019d5949-eb99-74be-b5c3-2cd94b5ec91d",
        "storage_key": "property/6767906449166454/019d5949-eb99-74be-b5c3-2cd94b5ec91d.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Walk-in closet with built-in shelves and hanging rods",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2826+of+39%29.jpg"
    },
    {
      "id": "custom_1b2d90fd-d5e8-4cb1-b9f2-1d2ac707412c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-edf7-740f-9a5d-97f77b8a3562.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a closet next to a bedroom with a bed and window.",
        "public_id": "019d5949-edf7-740f-9a5d-97f77b8a3562",
        "storage_key": "property/6767906449166454/019d5949-edf7-740f-9a5d-97f77b8a3562.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "View of a laundry closet with a washer and dryer, adjacent to a bedroom featuring a bed and a large window.",
      "link": "",
      "alt_text": "Washer and dryer in a closet next to a bedroom with a bed and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%288+of+39%29.jpg"
    },
    {
      "id": "custom_24986176-6c87-486b-8a58-d35877bb52f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-190d-772a-be57-356a2cbf127a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools.",
        "public_id": "019d5949-190d-772a-be57-356a2cbf127a",
        "storage_key": "property/6767906449166454/019d5949-190d-772a-be57-356a2cbf127a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Showcasing a stylish and functional kitchen featuring dark wood cabinetry, sleek stainless steel appliances, a spacious island with comfortable seating, and contemporary pendant lighting.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%282+of+69%29.jpg"
    },
    {
      "id": "custom_305bab40-5291-403e-a961-5beda50f7815",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-f527-73ec-9741-0a108dff32dd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "019d5949-f527-73ec-9741-0a108dff32dd",
        "storage_key": "property/6767906449166454/019d5949-f527-73ec-9741-0a108dff32dd.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark wood cabinetry, stainless steel appliances, and a spacious island perfect for meal prep and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+kitchen+..jpg"
    },
    {
      "id": "custom_34cf8c1f-ec17-4bd8-b026-3a3b45e15738",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-1ed8-7193-9eec-3b41120d43e7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a large island with bar stools.",
        "public_id": "019d5949-1ed8-7193-9eec-3b41120d43e7",
        "storage_key": "property/6767906449166454/019d5949-1ed8-7193-9eec-3b41120d43e7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Stunning kitchen featuring a large island with bar stools, perfect for casual dining and entertaining. Modern dark wood cabinetry and stainless steel appliances complete the look.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+kitchen.jpg"
    },
    {
      "id": "custom_07e6d926-67f9-4d05-b8fe-201392d7f8b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-fc99-72ac-8227-4918c9dec6a3.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs near a window.",
        "public_id": "019d5949-fc99-72ac-8227-4918c9dec6a3",
        "storage_key": "property/6767906449166454/019d5949-fc99-72ac-8227-4918c9dec6a3.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Dine in style at this apartment's elegant dining area, perfect for hosting friends and family.",
      "link": "",
      "alt_text": "Dining area with a table and chairs near a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+dining+area.jpg"
    },
    {
      "id": "custom_f937acb9-f0d4-4a69-ae1a-f3bc381dbb59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-1f08-7641-a2b4-9b2c3d94e973.webp",
      "image_media": {
        "alt_text": "Living room and dining area with furniture and decor",
        "public_id": "019d5949-1f08-7641-a2b4-9b2c3d94e973",
        "storage_key": "property/6767906449166454/019d5949-1f08-7641-a2b4-9b2c3d94e973.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A stylish living and dining area featuring a round wooden dining table, comfortable seating, a large TV, and decorative shelving.",
      "link": "",
      "alt_text": "Living room and dining area with furniture and decor",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%286+of+39%29.jpg"
    },
    {
      "id": "custom_f0cbd49f-1276-443c-a1bd-97d27659dbd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d5949-fe69-74de-b3d2-b9f048f0a3b8.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a round wooden table and chairs, a sofa, and a TV.",
        "public_id": "019d5949-fe69-74de-b3d2-b9f048f0a3b8",
        "storage_key": "property/6767906449166454/019d5949-fe69-74de-b3d2-b9f048f0a3b8.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a round wooden table with four chairs, a comfortable sofa, and a wall-mounted TV.",
      "link": "",
      "alt_text": "Living room and dining area with a round wooden table and chairs, a sofa, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%282+of+39%29.jpg"
    },
    {
      "id": "custom_8becea35-84b9-4921-a67c-9e15d5396008",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-02cc-760b-8f2a-7f5c02fa82c6.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sofa, ottoman, and dining table.",
        "public_id": "019d594a-02cc-760b-8f2a-7f5c02fa82c6",
        "storage_key": "property/6767906449166454/019d594a-02cc-760b-8f2a-7f5c02fa82c6.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furniture, large windows, and elegant decor. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living and dining area with a sofa, ottoman, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%284+of+69%29.jpg"
    },
    {
      "id": "custom_b84ba7f0-2a59-4e3f-a4e8-6a92b9f0e642",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-032e-74e1-9af7-99a02e339b81.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, plush bedding, and decorative wall art.",
        "public_id": "019d594a-032e-74e1-9af7-99a02e339b81",
        "storage_key": "property/6767906449166454/019d594a-032e-74e1-9af7-99a02e339b81.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy primary bedroom featuring a comfortable king-size bed dressed in striped linens and accented with decorative pillows. The room is enhanced with unique woven wall hangings and a minimalist nightstand.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed, plush bedding, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+2nd+bed.jpg"
    },
    {
      "id": "custom_02800e10-9df7-4976-a28c-9128c935b503",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-0ee2-71a3-a2a0-ff99d92a194f.webp",
      "image_media": {
        "alt_text": "King size bed with green bedding and white throw blanket, flanked by wooden nightstands with lamps.",
        "public_id": "019d594a-0ee2-71a3-a2a0-ff99d92a194f",
        "storage_key": "property/6767906449166454/019d594a-0ee2-71a3-a2a0-ff99d92a194f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with plush bedding, elegant nightstands, and a large window with scenic views. Perfect for restful nights.",
      "link": "",
      "alt_text": "King size bed with green bedding and white throw blanket, flanked by wooden nightstands with lamps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2-+model+bedroom.jpg"
    },
    {
      "id": "custom_f848bfa6-8a96-4c20-a917-f484eab7a643",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-0f24-744f-b658-f9b5c26b0bfe.webp",
      "image_media": {
        "alt_text": "Modern bathroom with wood vanity, white countertop, sink, toilet, and bathtub with white subway tile.",
        "public_id": "019d594a-0f24-744f-b658-f9b5c26b0bfe",
        "storage_key": "property/6767906449166454/019d594a-0f24-744f-b658-f9b5c26b0bfe.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a stylish wood-grain vanity, crisp white countertop, and a relaxing bathtub with classic subway tile.",
      "link": "",
      "alt_text": "Modern bathroom with wood vanity, white countertop, sink, toilet, and bathtub with white subway tile.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/Sorella+Apartments+HR+%2816+of+39%29.jpg"
    },
    {
      "id": "custom_ef4453a3-7a2d-4837-96a5-953c18f43af3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-1299-73a8-b3ca-91fd2b0d4152.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, large mirror, and walk-in closet.",
        "public_id": "019d594a-1299-73a8-b3ca-91fd2b0d4152",
        "storage_key": "property/6767906449166454/019d594a-1299-73a8-b3ca-91fd2b0d4152.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Elegantly designed bathroom featuring a spacious double vanity with modern fixtures, ample storage, and a large walk-in closet.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, large mirror, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+bath.jpg"
    },
    {
      "id": "custom_bbd2b713-9c30-4592-8975-5fd143397a61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-1317-74ee-b572-ca6000bfd338.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with modern cabinets and a doorway leading to a bedroom.",
        "public_id": "019d594a-1317-74ee-b572-ca6000bfd338",
        "storage_key": "property/6767906449166454/019d594a-1317-74ee-b572-ca6000bfd338.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Explore the spacious bathrooms and stylish vanities in our apartments. This image showcases a modern bathroom with ample storage and a view into the adjacent bedroom.",
      "link": "",
      "alt_text": "Bathroom vanity with modern cabinets and a doorway leading to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+bathtub.jpg"
    },
    {
      "id": "custom_0a6548d3-8816-4339-bb3a-ba0415741bab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d594a-1c8a-7243-8b9e-f0aff417bdf8.webp",
      "image_media": {
        "alt_text": "Washer and dryer with shelving and storage baskets.",
        "public_id": "019d594a-1c8a-7243-8b9e-f0aff417bdf8",
        "storage_key": "property/6767906449166454/019d594a-1c8a-7243-8b9e-f0aff417bdf8.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with convenient overhead shelving and additional pantry space.",
      "link": "",
      "alt_text": "Washer and dryer with shelving and storage baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/275a8051/dms3rep/multi/2x2+model+laundry.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e0bfda81-279a-4ccf-8993-16dbb5245ffb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "The Cove at Herriman Springs",
      "poi_type": "Entertainment",
      "poi_address": "6895 Rose Canyon Rd, Herriman, UT 84096, USA",
      "poi_short_description": "Family-friendly park with picnic tables and a grill, as well as a playground, a pond, and trails.",
      "poi_long_description": "Visitors say this park has nice playgrounds and beautiful walking areas where you can see ducks and geese. They also highlight the spectacular views, making it a great place to relax, talk, and enjoy the outdoors.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ-0G34MabUocR0tngm_CCclE/photos/AcnlKN2Y1UyNJjzrqd1FQyGuQeG1iAP88PvFqS7HuNhWc5wzAYX8Otfsh0daI8n9Z7GQ98K_OCyJpJVXdmxJApeKCPfJIldGjk1rwTihzwSh08GvVjOrCyyCsX8CFMudQJpf9pcV9Icf57rcHDiyQe6gkSbMd3ZUptGBzjorBtLvCjrzO73st7FfWvxSvkqrssmqHwa8EA1rnLiypvDCaTUamYA6tR0p3ljLXONiwKjvSOBbM-yOPmfVL71p4p8gZ3uyPapIsoaGHAkKOrbKN1GrRhbpGVA_lxi9rKfc3TOJwo_uEXQmP7qtWpZ-2cXI0RHekD47YjoT1BfGlhPdTxIvZzBkQ6RjoAtyu0QDtvfL1FizylFNxkUR0WAWLAiwXLSUH42XtokSds9x82k_7V4QAzpBJU11R78qeGjMe0RQKB_7U4E/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4000&maxHeightPx=3000",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.herriman.gov/parks/the-cove-at-herriman-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=5868897234336143826&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-cove-at-herriman-springs",
      "poi_latitude": "40.4945301",
      "poi_longitude": "-112.0556247",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-254-7667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-61d2-76d7-9989-02331826624a",
        "storage_key": "property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0G34MabUocR0tngm_CCclE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c3db3184-9415-4281-a736-c1c03d18e816",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Conservation Garden Park",
      "poi_type": "Entertainment",
      "poi_address": "8275 S 1300 W, West Jordan, UT 84088, USA",
      "poi_short_description": "Educational garden featuring exhibits of water-efficient plants & landscape designs, plus classes.",
      "poi_long_description": "People say this botanical garden offers a variety of beautiful flowers, trees, and bushes, and provides educational resources on water conservation and yard design. They highlight the peaceful and relaxing atmosphere, and the free entry. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJiTbHT92IUocRdg_jypT-jO4/photos/AcnlKN1X8r6d9WEV7EGi5QwWNPifsk0gCNhXk9LLZ-zFeGC3yd8uY5zkTNzkAh6zwaDJ9zM8vaAr0UbBhmkaWY68ygy3WsPftHY1flKlFnleneUXnNdQQX9SkPYmDcjtn9icpqS3JOk8b198sXdU2zaG2geFZR7ASIukRk_DFHm6ArfEPU9XKUFzEUzbp90ZkvYNLXbgu8XHsbRRGBKyv5iSjSBQ_HH1k_HFquHz7RLOwDYZMdf_dFTBqCiB2ivSlY_Fu-h16I94KRC4fvPTzzVM6rnV1CLgYN-Vorgo9CR1BhDFyPq7JzA9zFjJ4Kq2dEnpG7f27K1TmPnguV-aXG8vKlYcPm8ys7d6TtmScCNh5UvRwlQZ6uu93lzOMtl5SxJ_pyLkZUUED7vTEhzIa33l1xxTYNU89MoKF73KzDe7XM5Wd6I/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4000&maxHeightPx=3000",
      "poi_featured_image_media": null,
      "poi_business_url": "http://conservationgardenpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17189393792778833782&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "conservation-garden-park",
      "poi_latitude": "40.6009042",
      "poi_longitude": "-111.9272562",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-256-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-61d2-76d7-9989-02331826624a",
        "storage_key": "property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTbHT92IUocRdg_jypT-jO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_9a8012ef-e446-4bbe-a803-cd3143e32d40",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Red Door Escape Room",
      "poi_type": "Entertainment",
      "poi_address": "4554 W Partridge Hill Ln Suite D-108, Riverton, UT 84096, USA",
      "poi_short_description": "Interactive escape room center featuring themed games, a prison-break scenario.",
      "poi_long_description": "People say this escape room center offers fun and challenging rooms with creative puzzles and immersive experiences. They highlight the rooms are suitable for small groups and date nights, and the staff provides helpful hints and creates a fun atmosphere. They also like the friendly and enthusiastic game masters who enhance the overall experience.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJfdS3moeFUocR6ux5r9UhH6o/photos/AcnlKN3T46bP9K8SEif27PQqHfS1c-qKJgkZmHcw2yzvSbcTz7RubneOnGxKdZ9vuoaL1BWvD4BvHq7Qjb-krkskDMG4_OU9bzYph9LGrTjbJQKSCuvEqzfp4gf_ygt6c13VAe4CRZEVAgM2i9zqLLflWDHW9HbDpINPzngrNsTwkjonBnl-LGVouEbgP_N2Ag0nNR7zFy8Km2K2EtB3sFzvgfQTluE8RKNtCZE7ec7Fd-4Mda9stx3QDzsU1nBPDJ9BAAguj4un0mH4VusumwagEKDp1drQgQDWDFCXPsEDeIZcVA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1640&maxHeightPx=924",
      "poi_featured_image_media": null,
      "poi_business_url": "https://reddoorescape.com/escape-rooms/riverton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12258553912381533418&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-door-escape-room",
      "poi_latitude": "40.5095747",
      "poi_longitude": "-111.9995225",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-251-0208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdS3moeFUocR6ux5r9UhH6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_81882cfe-45ef-48ce-a4d7-aa31ccc49893",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "PEAK|45 Lagree Riverton",
      "poi_type": "Entertainment",
      "poi_address": "4534 W Partridge Hill Ln STE E-155, Riverton, UT 84096, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers challenging Lagree workouts that are effective for toning and strengthening. They highlight the instructors are motivating, energetic, and helpful, and the classes are fun and engaging. They also like the positive and supportive community.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJxddP55GFUocRTCbBY6fY70s/photos/AcnlKN1EEJwfAeZA74EJNmu1W7b8zT9ZziFX2TJIRIp-gweTtG8PLMc_1Tnw2v82E6aY1mCDPAzUU4Y4ythDe_5D3ySE8H_XwtoiMmXljI1_TDix6ezkYVf7HQH7eXmhhaWPLgn_FurleN1IZIZbfCb8IVzHzBpjEXb0wDIongIokmGmG86YQM4GsSDuyhSWkFOhBD8wmDpgi4aGRRDptptZCoQmU5p4ku6ycEVVgUU4FGJvbFOLoVT-IrSEq82rHzbTTQQ9kFj-VX7mG2p9E0neFdLD-_Xxi4g5UzgN4tLxrU82Ug/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.peak-45.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5471830285723182668&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peak45-lagree-riverton",
      "poi_latitude": "40.5092031",
      "poi_longitude": "-111.9989654",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-645-7325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxddP55GFUocRTCbBY6fY70s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_85dacde6-38af-4824-9190-c685585fd30b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Cinemark Riverton and XD",
      "poi_type": "Entertainment",
      "poi_address": "13257 S Teal Rdg Wy, Riverton, UT 84096, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers comfortable, reclining seats with heating and cooling options, as well as a wide selection of snacks and beverages, including a Coke Freestyle machine. They highlight the clean facilities, convenient showtimes, and the friendly and helpful staff. They also like the option to pre-order popcorn and drinks for pick-up.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJd0RyKfOFUocRzh_1TPi7nmU/photos/AcnlKN0VTCwzJSGk_xb06fu0pFtunQVqDLBe1YdkYQa4aK7MCsVGemr4u7kq4m0oNc4rIgNKuUb_yS-YJi7el-o4YEAkbhPRUBZxr0rjEUR-WPsqRPhuo81xaJouZjN3KbhEe7HvnKJLDPdnqu5AbeOQgm9HeBoX65ohP5k7c9zk4BQH3IUdn54kZT2SYc_QjKpZgDkyctDysCprz4kTaO31NgugupYI76sEXWg9vSiXsdym2F0VFCQJyBWFbYIWIBlT7Y96rPX1HeMf3wg1poOlPO5TNdIN0Xas-bRpYgagef2t-xZuXbu8vh9bz1piKXEHqdq71bEwAkzJUhoYtDhvU9zvwsWa1msXNYmKQwNh97Ysa69ukB1x6ghk3H3lVXovTX9--rtf2yieFRQIGG5herHUdwpRolnsxn9SmZmDo8I/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cinemark.com/theatres/ut-riverton/cinemark-riverton-and-xd?utm_medium=organic&utm_source=extnet&utm_campaign=local_listing_theater&utm_content=extnet_listing&y_source=1_MzU2Mzc5NTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7322496719268421582&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-riverton-and-xd",
      "poi_latitude": "40.5103568",
      "poi_longitude": "-111.9960468",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-938-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-1912-707a-8a73-b3d8a9622d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-1912-707a-8a73-b3d8a9622d68",
        "storage_key": "property/6767906449166454/019d02cf-1912-707a-8a73-b3d8a9622d68.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0RyKfOFUocRzh_1TPi7nmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_cc4411ca-24de-4a45-b1d9-e0ae66e9caca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Free People",
      "poi_type": "Shopping & Retail",
      "poi_address": "13347 S Teal Ridge Way, N-120 Ste N-120 Ste, Riverton, UT 84096, USA",
      "poi_short_description": "Women's clothing chain with a bohemian-inspired collection of dresses, jackets, shoes & accessories.",
      "poi_long_description": "Women's clothing chain with a bohemian-inspired collection of dresses, jackets, shoes & accessories.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJDeSs9S2FUocRvw6RcVt7Vns/photos/AcnlKN1pzc3Qbh8-UzlKFglrlosE5ihoGXR3T5rQgADNOTobdfEstJOTI1LfR4FPUm3hx9Wo2yMf3F4gOn4lsR-Buw6VWOeTACp14IwtQC6UpHHTeIIca_U7nbqMvQ7XUjlYIfDbItIMcT1_7Q14VakwH8Zm3nISV7CR_vsj3bxkXSNlux1UwdtTiZpw6g64WsQQaVek_-3z4jz81OEp7TO9Vnomb-t5GLzLhJ640mzrkmKKjdGlOjez1JPo95zl3IlLL2Ji3X9RFPyTWqkhuLKJ6oE3MqSIMAKR0ioDdnh5g7I7UQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=700&maxHeightPx=394",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.freepeople.com/stores/riverton?utm_medium=organic&utm_source=google&utm_campaign=local&utm_content=1885",
      "poi_directions_map_url": "https://maps.google.com/?cid=8887426547339824831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "free-people",
      "poi_latitude": "40.5088997",
      "poi_longitude": "-111.9950731",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-404-4249",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-568d-71fa-8551-ba2d136fc2d4",
        "storage_key": "property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDeSs9S2FUocRvw6RcVt7Vns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_abc854d5-b591-4e33-8ff7-c677749b1ec2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "SEPHORA",
      "poi_type": "Shopping & Retail",
      "poi_address": "13303 S Teal Rdg Wy M110, Riverton, UT 84096, USA",
      "poi_short_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_long_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJix9wQLkFU4cRNuzDwbEg09c/photos/AcnlKN3fqmwAHYhySKnazL5vLytMKLD7XpsXqL4oxURIhUDhaGyh0nRLAggui-8AKvAbaKQe0O30dhbrhx2LwdtoeUPiPdJFhh9lvDoMLmAvorH-BmkMo7dtdk5ZLdG39pNwNBrh9kAL03Sf9gGgPNdaie2mmFRLaLU2XIa-2hlUfOWgreCCDpaEeCxdFfhn--eNI8lHJeIprODMhsSR4yO_qMpoe1X-vKZjHZ8ZAljdyBLfaeN463uzrUIByAhlbSnhFt5sM1QCQECk1BXIgHOGopQ3id8Zr_0A3HESvcpoE9bSIRjgbZodYMzOqmz2SVH75DpajtZaEFcPJOj39b9S_MgxjryFeAuYNFnZuEXTI80MY6oNzrNW6ItsIJlrhHnoWWA0t6tY_IU6rTkvWwmPKfRzn69vN4u6eWQ9-uZ3x5eoptnS/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4000&maxHeightPx=3000",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.sephora.com/happening/stores/mountain-view-village?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=15551809886072597558&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sephora",
      "poi_latitude": "40.5097995",
      "poi_longitude": "-111.9955288",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-810-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-568d-71fa-8551-ba2d136fc2d4",
        "storage_key": "property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJix9wQLkFU4cRNuzDwbEg09c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_47cccb5a-7b07-4329-921b-6d65497f043c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "4654 Kestrel Range Rd, Riverton, UT 84096, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "People say this cosmetics store offers a wide variety of makeup and skincare products, and customers praise the helpful and friendly staff who go out of their way to assist shoppers. They also highlight the store's great customer service and the staff's willingness to help customers find the right products.\n\nSome reviews mention the store can be disorganized.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJlSBubOyBUocRnzeMQWLZDGw/photos/AcnlKN1fgQ9OHd1iRParRz8O3kirixHHY0qdNYf6Cg48_wSmnj-LHzaziNWEp2tKaKsomNct_iI3EEYdwVudzzF6F3xRsVPBE8y1t1zE8aG6IxU5qgWP-_Xe_qq-1EmsjH22hxSfW5AZLlLuxBB2G8eA0Ik8HtK6T3MayhgslygchJvIDE1FcKFBJGMqxojR9vr8wGcW1aqTD3lBE94loWmoXzM3AS-WJ1kWTlJaTdNL1xfhmi1EyCPYWeWeaGVqFmh8IFp4C5ZD01l53m3TBGH297rOK_TEYUqXrpOqvR_dDtctNA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=720&maxHeightPx=405",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ulta.com/stores/riverton-ut-1456",
      "poi_directions_map_url": "https://maps.google.com/?cid=7785836871846475679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "40.5108147",
      "poi_longitude": "-112.0005324",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-247-1470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-568d-71fa-8551-ba2d136fc2d4",
        "storage_key": "property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlSBubOyBUocRnzeMQWLZDGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_c8b91a68-a3af-44f4-a3ba-1bd000da2cea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "lululemon",
      "poi_type": "Shopping & Retail",
      "poi_address": "13303 S Teal Rdg Wy M100, Riverton, UT 84096, USA",
      "poi_short_description": "High-end yoga-focused chain featuring stylish athletic wear & accessories.",
      "poi_long_description": "High-end yoga-focused chain featuring stylish athletic wear & accessories.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJTdQKmFyFUocRsRVJ46W92Jk/photos/AcnlKN2kGhiFxI_hrsosLymRb39qmZ7lhl4RxsWa6hLoN13sYuSp6XBp-vEsMZIJJDsDa_TaNmb_xaKm4-iIGgjwaG_eQINtrNSm_Q4qGkmUvG6iw8i0bHf30Zs6NGOU3y4EMdFqyx-Mq4OtZq03MhOLFPt9h7nHs4vvE-1Fxn3gn_pgs6Lx57ZpBAfhRiXn8M-h9QCptZtjuVjLAgD_6Y8WFjYwnNBj6TmFIVE7BG5na-Bn2B3kzX7_WbBPOXKDZ9hGi3yX2YjILXVBbVkVQ9rANY8n7Nsspxn0LJ6-6pbXMGWl4VkLFKHeUokr5gShegorpW0Udmw1R_69a6bnV9AUToqwePWmnKjuL_usZaOplZUhbYZ7jx6ap2e9AGb2xIh3B89X1btMX7YDLh2denhTzrFAQU2XzTGB_hDfEU-Gr1zv2UIH/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=2665&maxHeightPx=3403",
      "poi_featured_image_media": null,
      "poi_business_url": "https://shop.lululemon.com/stores/us/riverton/mountain-view-village?utm_source=organic&utm_medium=local_listings&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=11085819002952947121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lululemon",
      "poi_latitude": "40.5100062",
      "poi_longitude": "-111.9956428",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-993-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-568d-71fa-8551-ba2d136fc2d4",
        "storage_key": "property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTdQKmFyFUocRsRVJ46W92Jk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_ad18afb2-2f6c-4602-a0e7-cf984b1a0a5a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "böhme",
      "poi_type": "Shopping & Retail",
      "poi_address": "13253 Teal Rdg Wy J160, Riverton, UT 84096, USA",
      "poi_short_description": "Dress and women's clothing retailer known for trendy pieces as well as classic items.",
      "poi_long_description": "",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJn_gjvMyFUocR_WCpXNB7Jfc/photos/AcnlKN2nIRgjeI8EwmBOTAmMwBrJAduWJ1tas6INumV7-5ctJ5y17QWVQ8TsM_7p1eDmKLM3LgjAZXvESJ9o1NeKd2o8JC6Mmvk2FfTZHGSBm40-oMmlR_op_wHnmIVIrUdLj8V-E7xqCci-XKQQU6PU33Mrq2XDGGG7PK4Pg61s8M7bVRDCPQpx6EIzoNAmbaMFLiUOuCaT9NB1RFHVMzJsVIp2qsmSs2hhzl2NcCAE5IwWoSYltksK7FYZxNN1qOv_8max_TEabbxN7uq3qES0pzxon_sRbVsm9mKmhNuba8IixfB45E_yGgG4Zp7GCTEqcfib-z9ipP4ze-0xFeYe5FY9Tyjnv354vIWk-XfTitlRnjbh1PrJIUFU701eaNNig5cqvLmhqZipOOc2npJq-2had1-KEOXQGml5PRXpUuxccPJ6/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1990&maxHeightPx=2488",
      "poi_featured_image_media": null,
      "poi_business_url": "https://bohme.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17808776436344512765&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bhme",
      "poi_latitude": "40.5104875",
      "poi_longitude": "-111.9967797",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-498-0450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-568d-71fa-8551-ba2d136fc2d4",
        "storage_key": "property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn_gjvMyFUocR_WCpXNB7Jfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_17d5a6e9-338c-4bcc-9e87-b71bad9de8dc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Mountain View Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "13303 Teal Rdg Wy, Riverton, UT 84096, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and dining options. They highlight the fun and vibrant atmosphere, and the convenient parking. They also like the beautiful design and well-planned layout.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJj6BjHfeEUocRdxYb2cpy6IM/photos/AcnlKN1RoUrC508U2Cx8slXVk1pEU65roE3aYhP5TX1k4q8-P5DQ-9Euz9saeMTVLWfgblYSXVxvb0R02givkJdd1PGnBtYxTNKDWUnpGT9ZamlxGc-BsE1UPzqbWNqGJdCWmDb3pIoRdO2Olf_YXFOgIt53Cb6s1NsYlPf2EgVYwJ9xdDktft2neJbch-IUE7ZEGPqAUIqlROJ3aDa3nCm_Mgp_viKEW0WTDgEm6dsNL336lE9JwukK9LkcPWldVgXj92VSxQ6UhawKyRtste5Y-ALpHkgW43OHAFXdgq4nNK1OKA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=782&maxHeightPx=325",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mountainviewvillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9504973229116823159&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mountain-view-village",
      "poi_latitude": "40.5109567",
      "poi_longitude": "-111.9980399",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-276-2832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-568d-71fa-8551-ba2d136fc2d4",
        "storage_key": "property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj6BjHfeEUocRdxYb2cpy6IM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a00a6167-b803-4743-8c98-dd8cb982af04",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Redemption Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "3517 W Maradona Dr, Herriman, UT 84065, USA",
      "poi_short_description": "Three-story sports bar serving pub grub, featuring live entertainment, trivia, and rooftop seating.",
      "poi_long_description": "People say this sports bar offers a great selection of food and drinks, including chili verde fries, citrus salmon, and wings. They highlight the fun atmosphere with live music, bingo, and a tiki lounge, and the reasonable prices. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ2ciu8R2DUocR0KdRzCHlxZc/photos/AcnlKN11UbcC8ymVXR0rw4EKk_jpKiftMjwerBpVXm1hrOk4YJTzQTkbU8nZnLUDqAzHORMP9f-Q31DKdXOb9t84u7yr_bwecbaCIjUCRDrjXC30DKM10hLUr1hl71hYItwpDehj3Lx3MniknlP1SYVj93zazLifPmRqn92d8fLUKAcYgxvYADFp47LT0c1FFfLJ9RN95jwOz1wguiR2Irexd0aYEz1bB9Y1pCt5VkrwrOSpaDkaAPLiPGwxV7yGg1XbjrcjmE-E0rMoBymMuCR2XGFwX3WDDc76bbb11M-_A2X6Og/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1536&maxHeightPx=1296",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.redemptionbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10936399203463702480&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redemption-bar--grill",
      "poi_latitude": "40.4769428",
      "poi_longitude": "-111.9751774",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-938-9363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-1a7c-71f4-8dca-3692cb0e4cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-1a7c-71f4-8dca-3692cb0e4cbe",
        "storage_key": "property/6767906449166454/019d02cf-1a7c-71f4-8dca-3692cb0e4cbe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ciu8R2DUocR0KdRzCHlxZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_32f6d3d7-629c-478d-8bed-6bc8c9c99ecd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Taqueria Chunga’s",
      "poi_type": "Restaurants",
      "poi_address": "13322 S Rosecrest Rd, Herriman, UT 84096, USA",
      "poi_short_description": "Laid-back eatery featuring al pastor tacos, grilled meat burritos and enchiladas.",
      "poi_long_description": "Diners say this restaurant serves up delicious al pastor tacos, burritos, and quesadillas, and they praise the fresh pineapple juice. They also highlight the friendly and efficient service, reasonable prices, and clean atmosphere.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJoYu_PXKFUocRYl22tqkorPY/photos/AcnlKN3l1zwjymjCb5Qi2mh142g1HFYJ0yepRmQGhD44uPoRJabuefhZ2l0Kjfq-7hFyAvUpVTmV-RWdrfTIOfjd75rX8dn1zswocbWrHp_5VIXe5pBApsZxPjNYt5C-9fMFCGoEg4oR23teVTX6-r-BcGfKLx2HJE7nZetNgTe5QVOcqyAsMRmCc8loIg7yarpZuyGiG6SempS9BhsbutpDBx22_P7cnhGvj7PnBmdTP_-ciQyhscalgswsm502Ctu7ln7L38zOqoul7hV0Z-INWsCGpTbepw1bsF3-fbROtN8HPQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1152&maxHeightPx=864",
      "poi_featured_image_media": null,
      "poi_business_url": "https://taqueriachungasut.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774626538704493922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "taqueria-chungas",
      "poi_latitude": "40.5103148",
      "poi_longitude": "-112.025006",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-679-9703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5691-7714-9f3a-dc888cbbb732",
        "storage_key": "property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoYu_PXKFUocRYl22tqkorPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0d38751f-0405-4259-ac14-6ff86f5f6084",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "North Italia",
      "poi_type": "Restaurants",
      "poi_address": "13303 S Teal Rdg Wy Suite M-150, Riverton, UT 84096, USA",
      "poi_short_description": "Regional eatery featuring pizzas, pastas, Italian entrees and desserts, plus a bar.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, pizza, and chicken pesto. They also highlight the fantastic olive oil, grilled bread, and tiramisu, and the attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJqd_NgCCFUocR80vZn09_GVQ/photos/AcnlKN0xbTWWRZQILiDmG6npyqHGhfwyeKaHuLidf7cVbZ6z3vQJWWObydq-4CXshoXnu_k-__h3uBtp4njXEbho6fQegV4oqZzVIoh-H3aIcyR0CoQAmBTmnrasz2Ve6LLmXhqyH6s7rktBlbHqBjP_sBfmoXtZ2dSzHegbENFDXCiED2Fbf0NmLZAHHuifOGhBSRYFywm1w_5fEU74lX6bqsKoqsyxb82-jm_6dkuXJi8_nA3uwgBooASyeA5FakbChQ3BHuM5AR_JvJakj2tReSwQes6W5U9ZzueAWsbGlGJNPQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3000&maxHeightPx=2001",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.northitalia.com/locations/riverton-ut/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6060014753564675059&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-italia",
      "poi_latitude": "40.5093445",
      "poi_longitude": "-111.9952934",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-506-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5691-7714-9f3a-dc888cbbb732",
        "storage_key": "property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqd_NgCCFUocR80vZn09_GVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_4ab33616-1507-4f22-8a79-382a42e5d113",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Chubby's Cafe Herriman",
      "poi_type": "Restaurants",
      "poi_address": "12271 Herriman Main St Unit B, Herriman, UT 84096, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Southern US restaurant serves delicious burgers, sandwiches, and beer-battered fries. They highlight the amazing value, generous portions, and the cozy, welcoming atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJBfnHfACFUocRP-61YYfav6A/photos/AcnlKN38c2oZU2fpYZsBtBoIpfvkL6_fWxE4GRVn0-1dSHDcEvmH0pMLQEmBKTJ-2FAumBEBuxohlU2l6BVudB4v8PQLHe8MQskYeAcEu_nqSF13lHNWtbgrdWKIWmZIabkdIgw5o8cDCktQKbIeINMkhlrGS-hJpU4z7wp9MhczmMLr3hBo8BE0bEPSy2RDw0V0Bo-3mc_itF1dvg1ZB-_4VmxQkpLtiaX4rGTNpdYZsEdJRErNAvQGZJRYagoL91YFwmjckOnhOrt5ONJINIK4NyaKRoZqCZzhpcsRaXJEzWWEtA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1536&maxHeightPx=1536",
      "poi_featured_image_media": null,
      "poi_business_url": "http://chubbyscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11583217041614958143&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chubbys-cafe-herriman",
      "poi_latitude": "40.52809",
      "poi_longitude": "-112.0137864",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-449-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5691-7714-9f3a-dc888cbbb732",
        "storage_key": "property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfnHfACFUocRP-61YYfav6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_79e02675-47f2-42d3-a005-46d825e6f702",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Slackwater Pizza Herriman",
      "poi_type": "Restaurants",
      "poi_address": "5197 Denali Park Dr, Herriman, UT 84096, USA",
      "poi_short_description": "Pizza spot known for its gourmet pies with unique toppings and local brews - plus a patio.",
      "poi_long_description": "People say this pizza restaurant serves delicious and unique pizzas with a variety of toppings, as well as salads, wings, and breadsticks. They highlight the amazing crust, the extensive beer selection, and the fun, laid-back atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJHX3VDgCFUocR6YYEJ6NcCHs/photos/AcnlKN17zZ5VoUF8y_xiBzOGgLJmvZN1n_VzipPDGu0twkZmSeLinbeQEhL7N2F9avX98uJ6ii86OZ2XbIBLB1yS18MaeH0rBajBbaRLhp-6TtRr47S2ohg6jWYxPb6pjphdZn1knATKPSEcGGa1ugCTng0oGGScSKkm0gDrbi6R64CsWFKqyjb7QpLGGSX4lynL7coqsBB8rX9zuLiSfEGsgVZhqFRxz100FAZscku9B0gH8Y30soDFZ5aQMPGLIEk9MtBcKVJ6YaZPavt9bYfb3tovv4BPlaX_RFG_yZJboosfBUam3FVUxOLnDQOEuw0U5bTUenvr257FkHewZqyUoYkEbfioBuVQD673iw9f_H5G6iXiwPgrVZB_AdTI4-mOTR6RUfB5wAhGApv6C8txXC5KWTxf9II4YYet00OIdsXKQOBr/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3600&maxHeightPx=4800",
      "poi_featured_image_media": null,
      "poi_business_url": "http://slackwaterpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8865437722282854121&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "slackwater-pizza-herriman",
      "poi_latitude": "40.5307965",
      "poi_longitude": "-112.0156319",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-207-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5691-7714-9f3a-dc888cbbb732",
        "storage_key": "property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHX3VDgCFUocR6YYEJ6NcCHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8f570eb1-0d64-407c-b333-0a7fbf2ce450",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Garage Grill & Salt Flats Bar Herriman",
      "poi_type": "Restaurants",
      "poi_address": "12547 Herriman Auto Row, Herriman, UT 84096, USA",
      "poi_short_description": "Wide-ranging American dishes share the menu with sushi at this comfortable restaurant featuring car memorabilia.",
      "poi_long_description": "Diners say this restaurant serves up delicious brisket sandwiches, sushi nachos, and fish and chips, and they praise the cool car-themed atmosphere, complete with vintage and modern race cars. They also highlight the friendly staff and great service.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cc-ff06-753f-8de5-99bf16c26bca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-ff06-753f-8de5-99bf16c26bca",
        "storage_key": "property/6767906449166454/019d02cc-ff06-753f-8de5-99bf16c26bca.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.thegaragegrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17743894256283797791&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "garage-grill--salt-flats-bar-herriman",
      "poi_latitude": "40.5237792",
      "poi_longitude": "-112.0068122",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-666-7767 ext. 1",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5691-7714-9f3a-dc888cbbb732",
        "storage_key": "property/6767906449166454/019d02cd-5691-7714-9f3a-dc888cbbb732.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTS580yFUocRH8njndD5PvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ce8cb961-a984-4176-b826-0e13f49c0964",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Daybreak Library",
      "poi_type": "Education",
      "poi_address": "11358 Grandville Ave, South Jordan, UT 84009, USA",
      "poi_short_description": "Modern library with meeting rooms and a roof terrace, plus a creative room.",
      "poi_long_description": "People say this library offers a wide variety of books, creative resources like 3D printers and sewing machines, and fun activities for kids. They highlight the spacious, clean, and creative facilities, and the helpful and welcoming staff. They also like the convenient location near the train station and the comfortable outdoor space with tables and chairs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-1074-73be-9759-71a3ac08f45a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1074-73be-9759-71a3ac08f45a",
        "storage_key": "property/6767906449166454/019d02cd-1074-73be-9759-71a3ac08f45a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.slcolibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12147180165645918044&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daybreak-library",
      "poi_latitude": "40.5445791",
      "poi_longitude": "-112.0155149",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 801-943-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5691-7714-9f3a-e1cd86f25536.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5691-7714-9f3a-e1cd86f25536",
        "storage_key": "property/6767906449166454/019d02cd-5691-7714-9f3a-e1cd86f25536.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVe4t2A-FUocRXN_-iwB0k6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_dac7e1f0-a58f-4ba1-b0f2-f775b98dbe07",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Salt Lake Community College (SLCC) Herriman Campus",
      "poi_type": "Education",
      "poi_address": "14551 Sentinel Ridge Blvd, Herriman, UT 84096, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-1229-715c-a3e5-2d1b6c4d8821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1229-715c-a3e5-2d1b6c4d8821",
        "storage_key": "property/6767906449166454/019d02cd-1229-715c-a3e5-2d1b6c4d8821.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.slcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11362689666041950184&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt-lake-community-college-slcc-herriman-campus",
      "poi_latitude": "40.4883428",
      "poi_longitude": "-111.9836125",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-957-6625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c81-717e-8f58-61a0e5e4b7d4",
        "storage_key": "property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBSMi3FiFUocR6K9ulQxisJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1e9d42d1-d9f4-4a27-a50c-d20b560826bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10534 S River Heights Dr, South Jordan, UT 84095, USA",
      "poi_short_description": "High-value chain gym with cardio machines and free weights, plus group classes and turf training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, weights, and massage chairs, and has amenities like a sauna, cryo beds, and a recovery room. They also highlight the friendly and helpful staff, and the clean and modern facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-1ed8-74a6-9b76-724844e82867.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1ed8-74a6-9b76-724844e82867",
        "storage_key": "property/6767906449166454/019d02cd-1ed8-74a6-9b76-724844e82867.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/south-jordan-s-jordan-pkwy-bangerter-hwy/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1658628844273705225&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "40.5593111",
      "poi_longitude": "-111.9732101",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 385-318-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4IERACFUocRCaEmZSWiBBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2a837ddc-adcd-4a18-8c3c-2a8f076214b3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10996 S River Front Pkwy, South Jordan, UT 84095, USA",
      "poi_short_description": "Club with an outdoor pool and a rock wall, plus a spa, tennis courts and a basketball court.",
      "poi_long_description": "People say this gym offers a variety of equipment and classes.\n\nOther reviews mention the membership can be expensive and the customer service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-1f78-70e3-8184-196d708033ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-1f78-70e3-8184-196d708033ef",
        "storage_key": "property/6767906449166454/019d02cd-1f78-70e3-8184-196d708033ef.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ut/south-jordan.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=4100501561270111315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "40.55176830000001",
      "poi_longitude": "-111.9183224",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 801-302-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuf_1skeGUocRU4xw0HHo5zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b99349be-88c7-4ed4-a2f8-b393d41b115b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13366 S Rosecrest Rd, Herriman, UT 84096, USA",
      "poi_short_description": "Vibrant fitness center offering cardio and weight machines and clean equipment, plus basketball courts.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and classes, including Studio Red. They also highlight the friendly and welcoming staff, the clean and comfortable environment, and the positive energy.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-2118-761c-a7f1-28c7ebc43011.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2118-761c-a7f1-28c7ebc43011",
        "storage_key": "property/6767906449166454/019d02cd-2118-761c-a7f1-28c7ebc43011.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/ut/herriman/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11534411971508558447&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "40.5090684",
      "poi_longitude": "-112.0266508",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-305-1610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYctySSGFUocRb9rHfpN2EqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1fbdf9d7-2fcd-4c83-9159-0de112191f6b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Mountain West Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "13860 S 2700 W, Bluffdale, UT 84065, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-29ba-73d2-8f74-3fd7b24b32fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-29ba-73d2-8f74-3fd7b24b32fe",
        "storage_key": "property/6767906449166454/019d02cd-29ba-73d2-8f74-3fd7b24b32fe.webp",
        "width": 829,
        "height": 467
      },
      "poi_business_url": "https://www.mtnwestvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1710903624145721865&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountain-west-veterinary-specialists",
      "poi_latitude": "40.499305",
      "poi_longitude": "-111.959603",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-515-5011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxYSyZEWFUocRCVoiCshZvhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_26eb25d1-59cd-468a-86d8-bfce3cf2c880",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11539 4000 W, South Jordan, UT 84009, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-2e95-7797-900a-5e9128a8cd9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-2e95-7797-900a-5e9128a8cd9b",
        "storage_key": "property/6767906449166454/019d02cd-2e95-7797-900a-5e9128a8cd9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-jordan-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3147488620595771110&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.54089889999999",
      "poi_longitude": "-111.9857952",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-446-9975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7T5PFJeFUocR5vYxbTkgris",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87795e52-a0e3-4f30-afd1-05378572f0e7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Olympus Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "1357 South Jordan Pkwy, South Jordan, UT 84095, USA",
      "poi_short_description": "Gymnastics center with programs for children and teens, plus a ninja class.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-30a5-7295-9548-f54d8c7468ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-30a5-7295-9548-f54d8c7468ba",
        "storage_key": "property/6767906449166454/019d02cd-30a5-7295-9548-f54d8c7468ba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.olympusgymnastics.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2264129943978798346&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olympus-gymnastics",
      "poi_latitude": "40.5617582",
      "poi_longitude": "-111.930718",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 801-446-0279",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c81-717e-8f58-61a0e5e4b7d4",
        "storage_key": "property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3WxPvCqGUocRCm0uLDDOax8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5175ed14-c3f5-4408-8ab1-88c30e7d7d83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Intermountain Health Riverton Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3741 W 12600 S, Riverton, UT 84065, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-30dd-7245-89a6-2b74070c55e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-30dd-7245-89a6-2b74070c55e4",
        "storage_key": "property/6767906449166454/019d02cd-30dd-7245-89a6-2b74070c55e4.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/riverton-hospital?utm_campaign=gmb&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18327732780611534900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intermountain-health-riverton-hospital",
      "poi_latitude": "40.520496",
      "poi_longitude": "-111.9804623",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-285-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-6169-7289-aa8f-a78638d53946.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-6169-7289-aa8f-a78638d53946",
        "storage_key": "property/6767906449166454/019d02cd-6169-7289-aa8f-a78638d53946.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfcNMkuEUocRNACiBtwvWf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ccf797be-5cb4-470d-b138-5e2bb7c494d9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Lone Peak Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "11925 State St, Draper, UT 84020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-34f0-720b-9335-304710589752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-34f0-720b-9335-304710589752",
        "storage_key": "property/6767906449166454/019d02cd-34f0-720b-9335-304710589752.webp",
        "width": 834,
        "height": 469
      },
      "poi_business_url": "http://www.lonepeakhospital.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4522884303410043065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lone-peak-hospital",
      "poi_latitude": "40.5354904",
      "poi_longitude": "-111.8889613",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 801-545-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-6169-7289-aa8f-a78638d53946.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-6169-7289-aa8f-a78638d53946",
        "storage_key": "property/6767906449166454/019d02cd-6169-7289-aa8f-a78638d53946.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQvHjQiHUocRuRjyiE-DxD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d57e2012-b2e7-4564-a184-1164a3e8ccda",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Ashton Gardens at Thanksgiving Point",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3900 Garden Dr, Lehi, UT 84043, USA",
      "poi_short_description": "Sprawling 50-acre site offering themed gardens, a cafe, and annual events like a tulip festival.",
      "poi_long_description": "People say this botanical garden offers a beautiful Tree of Life exhibit, stunning flowers, and a peaceful atmosphere. They highlight the spacious grounds, the availability of golf cart rentals, and the fun scavenger hunt. They also like the friendly staff and the amazing photo opportunities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-3524-70f3-8524-713918a132f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-3524-70f3-8524-713918a132f8",
        "storage_key": "property/6767906449166454/019d02cd-3524-70f3-8524-713918a132f8.webp",
        "width": 800,
        "height": 534
      },
      "poi_business_url": "https://thanksgivingpoint.org/attractions-tickets/ashton-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14354104200981058519&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ashton-gardens-at-thanksgiving-point",
      "poi_latitude": "40.4363182",
      "poi_longitude": "-111.9115113",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 801-768-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-61d2-76d7-9989-02331826624a",
        "storage_key": "property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6vYLSeAUocR1xNrMLgFNMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_6370b03b-460d-4942-b882-a6efb3395f54",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Wardle Fields Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14148 S 2700 W, Bluffdale, UT 84065, USA",
      "poi_short_description": "Splash-pad park with a playground, plus picnic tables, basketball hoops, zip lines, slides, a baseball field and a fountain.",
      "poi_long_description": "People say this park offers a fun splash pad, zip line, playground, and pickleball courts. They highlight the clean facilities, ample parking, and shady spots. They also like the large pavilion and smaller pavilions, perfect for picnics and gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-373f-7409-8834-a928764832d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-373f-7409-8834-a928764832d0",
        "storage_key": "property/6767906449166454/019d02cd-373f-7409-8834-a928764832d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://slco.org/parks-recreation/parks-trails/all-parks/wardle-fields-regional-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672956594043774302&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wardle-fields-regional-park",
      "poi_latitude": "40.4955787",
      "poi_longitude": "-111.9591993",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 385-468-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-61d2-76d7-9989-02331826624a",
        "storage_key": "property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8QElEgWEUocRXmVcLBKIXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59c77ffd-1735-4687-92d7-7af8389a45ee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Galena Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 S 550 W, Draper, UT 84020, USA",
      "poi_short_description": "Grass park for softball games and picnics featuring a playground, volleyball and soccer fields.",
      "poi_long_description": "People say this park offers well-maintained fields, a dog park, and a playground suitable for children of all ages. They highlight the convenient amenities, such as restrooms and parking, and the safe environment with proper fencing and well-marked boundaries. They also like the beautiful views from the dog park and some of the baseball arenas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-3825-77a9-a33a-a2b8567399f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-3825-77a9-a33a-a2b8567399f3",
        "storage_key": "property/6767906449166454/019d02cd-3825-77a9-a33a-a2b8567399f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.draper.ut.us/index.aspx?NID=556",
      "poi_directions_map_url": "https://maps.google.com/?cid=1842958902220596146&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "galena-hills-park",
      "poi_latitude": "40.5233825",
      "poi_longitude": "-111.9083476",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 801-576-6570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-61d2-76d7-9989-02331826624a",
        "storage_key": "property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgb-2y-OGUocRsqOAbluBkxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6bcef4b4-8242-45c6-8650-3db097403402",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Riverbend Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1040 W 12800 S, Riverton, UT 84065, USA",
      "poi_short_description": "Riverside golf destination featuring an 18-hole course, plus a restaurant & lessons.",
      "poi_long_description": "People say this golf course offers a fun and challenging experience with well-maintained greens and fairways. They also highlight the fair prices and good pace of play.\n\nOther reviews mention the course can be difficult for beginners.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-3b95-7404-b852-850b4e136201.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-3b95-7404-b852-850b4e136201",
        "storage_key": "property/6767906449166454/019d02cd-3b95-7404-b852-850b4e136201.webp",
        "width": 1280,
        "height": 860
      },
      "poi_business_url": "https://www.saltlakecounty.gov/parks-recreation/facilities-and-golf/golf/riverbend-golf-course/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12817896687753483246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverbend-golf-course",
      "poi_latitude": "40.518491",
      "poi_longitude": "-111.921009",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 385-468-1460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-62b8-70be-a4cb-c41b62ce54cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-62b8-70be-a4cb-c41b62ce54cf",
        "storage_key": "property/6767906449166454/019d02cd-62b8-70be-a4cb-c41b62ce54cf.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1j0XOmGUocR7tMzGSBR4rE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_3f3a6757-ad2a-451e-bb3e-d8810b169afd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Riverton City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1452 W 12600 S, Riverton, UT 84065, USA",
      "poi_short_description": "Popular recreation area with playgrounds, picnic spots and splash pads, plus skate ramps.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, a splash pad, pickleball and tennis courts, and a large pavilion. They highlight the expansive grassy areas, mature trees providing shade, and the well-maintained grounds. They also like the clean restrooms and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-3bea-766f-b9c8-c2d261042904.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-3bea-766f-b9c8-c2d261042904",
        "storage_key": "property/6767906449166454/019d02cd-3bea-766f-b9c8-c2d261042904.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rivertonutah.gov/parks/locations/riverton-city-park.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=14993672453304018960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverton-city-park",
      "poi_latitude": "40.5201392",
      "poi_longitude": "-111.9326105",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-208-3101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-61d2-76d7-9989-02331826624a",
        "storage_key": "property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl6PRSZKGUocREOi-Cag5FNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3f09b7bc-bd8a-4918-9ba0-84b8303e1ebf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Draper Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Draper, UT 84020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-3ea7-71fd-a067-fa3a54a6db29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-3ea7-71fd-a067-fa3a54a6db29",
        "storage_key": "property/6767906449166454/019d02cd-3ea7-71fd-a067-fa3a54a6db29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rideuta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13199636932909897604&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "draper-station",
      "poi_latitude": "40.5156091",
      "poi_longitude": "-111.9044106",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-6309-75d3-afd6-3a77bb9815a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-6309-75d3-afd6-3a77bb9815a6",
        "storage_key": "property/6767906449166454/019d02cd-6309-75d3-afd6-3a77bb9815a6.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TOtgSCHUocRhJc4FtuHLrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_ef86b0ce-1c95-424d-9757-c1b9b7de2d42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Daybreak Parkway Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "South Jordan, UT 84009, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-4040-71ec-822b-00d6d24ea8a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-4040-71ec-822b-00d6d24ea8a1",
        "storage_key": "property/6767906449166454/019d02cd-4040-71ec-822b-00d6d24ea8a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=733309488350824391&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daybreak-parkway-station",
      "poi_latitude": "40.54387639999999",
      "poi_longitude": "-112.0139869",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7XVlm-FUocRxweTKxg9LQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_31128983-111e-434d-8458-97f4582f8db9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "5600 W. Old Bingham Hwy Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "West Jordan, UT 84081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-42ab-7325-89b9-6af90caf38b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-42ab-7325-89b9-6af90caf38b0",
        "storage_key": "property/6767906449166454/019d02cd-42ab-7325-89b9-6af90caf38b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15564242111547622275&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "5600-w-old-bingham-hwy-station",
      "poi_latitude": "40.569441",
      "poi_longitude": "-112.024871",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wVP2eqPUocRg8P40LxL_9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ed1f6515-ff79-4e4e-b8ca-005afc9a6efa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "South Jordan Parkway Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "South Jordan, UT 84009, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-459c-739b-b4d1-bf056636cc27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-459c-739b-b4d1-bf056636cc27",
        "storage_key": "property/6767906449166454/019d02cd-459c-739b-b4d1-bf056636cc27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13111353503472031864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-jordan-parkway-station",
      "poi_latitude": "40.558395",
      "poi_longitude": "-112.024764",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2HyOPOPUocReBgGY4vi9LU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_bd7108ce-3dc6-4b47-b988-269cff7dd64e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "BILL",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13707 S 200 W STE 100, Draper, UT 84020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-47a1-74aa-bd7b-5d5902d2a647.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-47a1-74aa-bd7b-5d5902d2a647",
        "storage_key": "property/6767906449166454/019d02cd-47a1-74aa-bd7b-5d5902d2a647.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14272818740335334797&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bill",
      "poi_latitude": "40.5024307",
      "poi_longitude": "-111.8921288",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-229-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTvXWy-AUocRjdU5EQY9E8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_18fa8094-866a-4f2f-ac7f-a508dcdc0e56",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Acima",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13893 Minuteman Dr, Draper, UT 84020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-49df-7449-93ac-6eb8bc9913fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-49df-7449-93ac-6eb8bc9913fe",
        "storage_key": "property/6767906449166454/019d02cd-49df-7449-93ac-6eb8bc9913fe.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.acima.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11570969740168011839&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "acima",
      "poi_latitude": "40.4998739",
      "poi_longitude": "-111.8898134",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-297-1980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ02Q5xiyIUocRPyCCTaxXlKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_52b42dfd-13d7-4806-88f6-510cc8951853",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Cricut, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10855 S River Front Pkwy #300, South Jordan, UT 84095, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-49d7-7429-a2ca-48c84e156927.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-49d7-7429-a2ca-48c84e156927",
        "storage_key": "property/6767906449166454/019d02cd-49d7-7429-a2ca-48c84e156927.webp",
        "width": 790,
        "height": 768
      },
      "poi_business_url": "https://cricut.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3526089701309332585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cricut-inc",
      "poi_latitude": "40.5537271",
      "poi_longitude": "-111.9124191",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 877-727-4288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0c23jeGUocRaby0vOYv7zA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ac9a38ff-2424-4b7f-a249-7487ba704e56",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Herriman City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5355 W Main St, Herriman, UT 84096, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-4cc2-7641-90c1-1426f3e8dc33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-4cc2-7641-90c1-1426f3e8dc33",
        "storage_key": "property/6767906449166454/019d02cd-4cc2-7641-90c1-1426f3e8dc33.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.herriman.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2668918845576764374&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herriman-city-hall",
      "poi_latitude": "40.5164704",
      "poi_longitude": "-112.0169717",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-446-5323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5691-7714-9f3a-e1cd86f25536.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5691-7714-9f3a-e1cd86f25536",
        "storage_key": "property/6767906449166454/019d02cd-5691-7714-9f3a-e1cd86f25536.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0sbtx2FUocR1tvyrIznCSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_55055f89-f6f6-40f3-b18d-a993d8d0dbf2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "1-800 Contacts",
      "poi_type": "Major Employers & Offices",
      "poi_address": "261 W Data Dr, Draper, UT 84020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-4ec2-7329-8065-d1122e8f888b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cd-4ec2-7329-8065-d1122e8f888b",
        "storage_key": "property/6767906449166454/019d02cd-4ec2-7329-8065-d1122e8f888b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.1800contacts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14937482030901222343&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "1-800-contacts",
      "poi_latitude": "40.5077549",
      "poi_longitude": "-111.8992412",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-266-8228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5AyKs2AUocRx9ul0sOYTM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_311f878e-daa7-4d1a-b744-b8a4cd51b736",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Nike Mountain View Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "13348 Teal Rdg Wy Ste N-140, Riverton, UT 84096, USA",
      "poi_short_description": "Store in Mountain View Village for sportswear and shoes for men, women, and kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019eb42d-5fbf-739f-8ad1-561b657226de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb42d-5fbf-739f-8ad1-561b657226de",
        "storage_key": "property/6767906449166454/019eb42d-5fbf-739f-8ad1-561b657226de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.nike.com/retail/s/nike-well-collective-riverton?cp=84620811901_seo_&y_source=1_NDY1NjkxMzAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14795566684850224096&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nike-mountain-view-village",
      "poi_latitude": "40.5088194",
      "poi_longitude": "-111.9949513",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-274-6611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-568d-71fa-8551-ba2d136fc2d4",
        "storage_key": "property/6767906449166454/019d02cd-568d-71fa-8551-ba2d136fc2d4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEzUfQ6GFUocR4PsZdYJpVM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sportswear_store"
    },
    {
      "id": "custom_a5c09bf1-90e3-41fc-8c48-98b14731d13a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Ridge View Elementary School",
      "poi_type": "Education",
      "poi_address": "14120 S Greenford Ln, Herriman, UT 84096, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f01ee-a470-717c-a3dd-6b77e3775e8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01ee-a470-717c-a3dd-6b77e3775e8f",
        "storage_key": "property/6767906449166454/019f01ee-a470-717c-a3dd-6b77e3775e8f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ridgeview.jordandistrict.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16956422937719879652&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridge-view-elementary-school",
      "poi_latitude": "40.4953308",
      "poi_longitude": "-111.9943383",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-567-8930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c81-717e-8f58-61a0e5e4b7d4",
        "storage_key": "property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ49WoiSyFUocR5DcUqNJQUes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b51639f3-a5a6-4b05-b775-1afa9bda7099",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "South Hills Middle School",
      "poi_type": "Education",
      "poi_address": "13508 4000 W, Riverton, UT 84065, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f01ee-a450-734c-80d3-b3f19c3cd226.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01ee-a450-734c-80d3-b3f19c3cd226",
        "storage_key": "property/6767906449166454/019f01ee-a450-734c-80d3-b3f19c3cd226.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://southhills.jordandistrict.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18123603794947493575&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "south-hills-middle-school",
      "poi_latitude": "40.5058548",
      "poi_longitude": "-111.9878336",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-412-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c81-717e-8f58-61a0e5e4b7d4",
        "storage_key": "property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTx_jFkOEUocRx07E56D5g_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_51ebc7ae-dd02-4967-b12e-e61925616544",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Mountain Ridge High School",
      "poi_type": "Education",
      "poi_address": "14100 Sentinel Ridge Blvd, Herriman, UT 84096, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f01ee-a451-70ff-8714-35a069f2b8f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01ee-a451-70ff-8714-35a069f2b8f6",
        "storage_key": "property/6767906449166454/019f01ee-a451-70ff-8714-35a069f2b8f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://mountainridgesentinels.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8418457703826505294&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mountain-ridge-high-school",
      "poi_latitude": "40.4951554",
      "poi_longitude": "-111.9979371",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-412-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c81-717e-8f58-61a0e5e4b7d4",
        "storage_key": "property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbw1No3iFUocRTr46wa1e1HQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_739a0939-1f4a-416b-ba92-52132e0f113a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "W & M Butterfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Butterfield Park, 6212 Butterfield Park Way, Herriman, UT 84096, USA",
      "poi_short_description": "Clean, spacious city park featuring baseball fields for kids and adults, and a playground.",
      "poi_long_description": "People say this park offers a big playground, large green areas, and baseball fields, making it great for family sports and events. They also highlight the clean ball fields and the presence of a snack bar. Visitors appreciate the open area with numerous fields, noting it's a good place for kids' activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d403d-5d49-7786-a89f-a3bfa6d240cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d403d-5d49-7786-a89f-a3bfa6d240cd",
        "storage_key": "property/6767906449166454/019d403d-5d49-7786-a89f-a3bfa6d240cd.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.herriman.gov/parks/butterfield-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10560667949258386219&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "w--m-butterfield-park",
      "poi_latitude": "40.4956956",
      "poi_longitude": "-112.0378806",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-254-7667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-61d2-76d7-9989-02331826624a",
        "storage_key": "property/6767906449166454/019d02cd-61d2-76d7-9989-02331826624a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEaLUtsuEUocRKytmCowHj5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_57dd493c-35eb-45a2-a133-411a7965675a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "UTA Route F556 - Herriman/Riverton",
      "poi_type": "Transportation & Transit",
      "poi_address": "13400 S & Anthem Park Blvd, Herriman, UT 84096",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "15",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4d0462f7-a0eb-4d30-ba76-d934151adffe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "UTA Route 551 - Riverton/South Jordan",
      "poi_type": "Transportation & Transit",
      "poi_address": "13400 S & Redwood Rd, Riverton, UT 84065",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "25",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6172d8eb-554a-4124-b5e2-43ae73349ed4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Mountain America Credit Union - Herriman: Rosecrest Road Branch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13388 S Rosecrest Rd, Herriman, UT 84096, USA",
      "poi_short_description": "Financial institution offering savings and checking accounts, plus auto and home loans.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f01ee-a46f-740a-ab5a-6df3a9a6b742.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f01ee-a46f-740a-ab5a-6df3a9a6b742",
        "storage_key": "property/6767906449166454/019f01ee-a46f-740a-ab5a-6df3a9a6b742.webp",
        "width": 542,
        "height": 287
      },
      "poi_business_url": "https://www.macu.com/branch-locations/utah/salt-lake-county/herriman-branch?cid=ea-gmb-website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4682367094355350684&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mountain-america-credit-union---herriman-rosecrest-road-branch",
      "poi_latitude": "40.5083344",
      "poi_longitude": "-112.0250722",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-253-6630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJcEWLt6EUocRnFQHZxAc-0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_c1ee3383-8893-4cd3-a647-6ce653dd8afc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Small Wonders Preschool",
      "poi_type": "Education",
      "poi_address": "13282 S 5600 W, Herriman, UT 84096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f064d-b0ad-737c-b393-b326d06b1fa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f064d-b0ad-737c-b393-b326d06b1fa2",
        "storage_key": "property/6767906449166454/019f064d-b0ad-737c-b393-b326d06b1fa2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.smallwonderspreschoolinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14364449483600405444&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "small-wonders-preschool",
      "poi_latitude": "40.5112758",
      "poi_longitude": "-112.0257115",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 801-878-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c81-717e-8f58-61a0e5e4b7d4",
        "storage_key": "property/6767906449166454/019d02cd-5c81-717e-8f58-61a0e5e4b7d4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQeQxMN6EUocRxKMLALPGWMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_88870f3d-d550-423b-8d3d-f914818234d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "poi_name": "Blackridge Reservoir",
      "poi_type": "Entertainment",
      "poi_address": "15000 S Ashland Ridge Dr, Herriman, UT 84096, USA",
      "poi_short_description": "Lake offering a sandy beach for swimming and sunbathing, a playground and covered pavilions, plus boat rentals and trails.",
      "poi_long_description": "Visitors say this reservoir offers sandy beaches, a playground, and hiking trails, with options for swimming and paddleboarding. They also highlight the convenient parking and clean restrooms.\n\nSome reviews mention the parking can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f064d-b008-77eb-8ea4-58eb67e00ee8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f064d-b008-77eb-8ea4-58eb67e00ee8",
        "storage_key": "property/6767906449166454/019f064d-b008-77eb-8ea4-58eb67e00ee8.webp",
        "width": 1280,
        "height": 652
      },
      "poi_business_url": "https://www.herriman.gov/parks/blackridge-reservoir",
      "poi_directions_map_url": "https://maps.google.com/?cid=15298083341952254984&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "blackridge-reservoir",
      "poi_latitude": "40.47975",
      "poi_longitude": "-112.0212549",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 801-446-5323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cd-5c2e-70fe-a346-cda28ac8d500",
        "storage_key": "property/6767906449166454/019d02cd-5c2e-70fe-a346-cda28ac8d500.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXQf1Z6EUocRCIRiLb-1TdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    }
  ],
  "office_hours": [
    {
      "id": "ec_442f751adbeb5a118d4830c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3ffe2b93088377b5ab7248c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2667dd3b6e6751613718ad45",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_59ee2660ef36b410d05f79e9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_56cb48e9ed4b9a2302f48997",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b5f376022ce0b80387a37669",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1af6d49a-d99d-4ac7-a9e3-b07a995cc107",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "rating": "5.0",
      "name": "Grace Carsey",
      "text": "Sorella Apartments has been nothing short of incredible! From the moment we reached out, the office team—especially Kori—went above and beyond to help us through every step of the process. We felt supported and informed the whole way through. We couldn’t have asked for a better experience.\n\nThe apartment itself is absolutely gorgeous—bright and clean. Everything feels fresh and high-quality, from the finishes to the layout. The location is also perfect: close to everything we need but still peaceful and quiet. We’re so grateful to have found this place!",
      "date": "2025-06-10",
      "title": ""
    },
    {
      "id": "custom_d4c8b908-1f2b-48f2-9df3-8424ca8214f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "rating": "5.0",
      "name": "Gabss",
      "text": "The leasing office is amazing, I was attended by a wonderful girl named Zeni and she helped me through the whole process, she was patient regardless of my lack of understanding when she was explaining things over. I can definitely say have a wonderful staff that you can communicate your concerns to! Guaranteed to have things taken care of.",
      "date": "2025-09-11",
      "title": ""
    },
    {
      "id": "custom_9a3d0380-2d1e-4575-a486-cfcded8d1325",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "rating": "5.0",
      "name": "Karoline Caridad Breindembach Gerik",
      "text": "I want to give a big thank you to Zeni at Sorella Apartments! She has been so helpful and supportive throughout the whole process. Any time I had questions, she was patient, kind, and always made sure I felt comfortable and taken care of. It’s rare to find someone who truly goes above and beyond, and Zeni does just that. I really appreciate her professionalism and the welcoming environment she creates at Sorella.",
      "date": "2025-09-18",
      "title": ""
    },
    {
      "id": "custom_37ad5c39-2eb0-472e-b1a0-49eca8df0760",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "rating": "5.0",
      "name": "Rose Corella",
      "text": "I'm writing to express my sincere appreciation for the wonderful experience I've had living here. The property management has been excellent, and I truly value the efforts you all put in.\n\nIn particular, I wanted to commend Clint from the maintenance team. He is consistently thorough and ensures that everything within my unit and around the property is working really well. His dedication to his work is evident, and I genuinely appreciate his responsiveness and positive attitude whenever he addresses any maintenance needs. It makes a real difference to know that issues are handled promptly and effectively.\n\nBecause of the excellent management and the fantastic maintenance support provided by people like Clint, I would definitely recommend this community to others looking for a great place to live.",
      "date": "2025-04-25",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_454739ea-024d-42c4-b91f-daede1d38262",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08d7-73ac-9d5d-f13c3eae40b9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08d7-73ac-9d5d-f13c3eae40b9",
        "storage_key": "property/6767906449166454/019f6c19-08d7-73ac-9d5d-f13c3eae40b9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 624 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WEAiUN6JXQC"
    },
    {
      "id": "custom_f1be1cb1-80c7-4d17-bf55-47e775194354",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08f7-720c-88a2-23d7d5bbf8ce.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08f7-720c-88a2-23d7d5bbf8ce",
        "storage_key": "property/6767906449166454/019f6c19-08f7-720c-88a2-23d7d5bbf8ce.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 727 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=N42PPMiufrh"
    },
    {
      "id": "custom_097057fb-6cad-4f57-a0ea-84100c0a8885",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08b4-74e8-aa95-1d86403c8404.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08b4-74e8-aa95-1d86403c8404",
        "storage_key": "property/6767906449166454/019f6c19-08b4-74e8-aa95-1d86403c8404.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 748 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LNMN352fcST"
    },
    {
      "id": "custom_585ad39f-e601-4633-b992-514f6c1f234b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-0898-75b1-a1ca-24d986ec3760.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-0898-75b1-a1ca-24d986ec3760",
        "storage_key": "property/6767906449166454/019f6c19-0898-75b1-a1ca-24d986ec3760.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 831 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4zSMat2smac"
    },
    {
      "id": "custom_e94f8ec8-36d4-42e4-8520-720025d0201a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08d5-705d-b0b3-5b86f424cc32.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08d5-705d-b0b3-5b86f424cc32",
        "storage_key": "property/6767906449166454/019f6c19-08d5-705d-b0b3-5b86f424cc32.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 954 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vR2ojhk9uwt"
    },
    {
      "id": "custom_4c47fa95-5ee9-4c54-bf15-4ae83e09ab11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08f6-73bf-8473-bff21a364c43.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08f6-73bf-8473-bff21a364c43",
        "storage_key": "property/6767906449166454/019f6c19-08f6-73bf-8473-bff21a364c43.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1043 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kJ3t5XGTomc"
    },
    {
      "id": "custom_6ca20576-b730-44c1-9cd4-b87c45b96a14",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08e6-75e9-bee1-83fc75964a8e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08e6-75e9-bee1-83fc75964a8e",
        "storage_key": "property/6767906449166454/019f6c19-08e6-75e9-bee1-83fc75964a8e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1205 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=47wu3ei6Xsu"
    },
    {
      "id": "custom_91a659a8-a474-48d4-87df-ed04efd0ff80",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08e6-75e9-bee1-7f335b0ea305.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08e6-75e9-bee1-7f335b0ea305",
        "storage_key": "property/6767906449166454/019f6c19-08e6-75e9-bee1-7f335b0ea305.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1207 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=K1o1LUqoFjW"
    },
    {
      "id": "custom_df7ef8da-2a22-46b4-b912-0d00ff979258",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019f6c19-08ed-76a1-8009-43d16a2cf69b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-08ed-76a1-8009-43d16a2cf69b",
        "storage_key": "property/6767906449166454/019f6c19-08ed-76a1-8009-43d16a2cf69b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 3 BR, 2 BA | 1222 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2Tr5sLFP6Sa"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199e00b-4302-749d-951e-9ac0b1ed623d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-sorella-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454"
    },
    {
      "lead_collector_id": "019d4044-cf95-746d-9490-6f64cffd6eed",
      "lead_source": "LANDING_PAGE",
      "name": "amc-sorella-lp",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "heated-pool-apartments-herriman-ut-sorella",
      "search_query": "heated pool apartments in Herriman UT",
      "category": "Amenity",
      "h1_title": "Heated Pool Apartments in Herriman, UT",
      "h2_subtitle": "Relax at Sorella's heated pool in Herriman, UT. Discover luxurious living with exceptional amenities right at your doorstep.",
      "page_copy": "Discover your perfect home at Sorella, where our heated pool offers year-round relaxation in Herriman, UT. Immerse yourself in comfort and luxury with access to our modern amenities, including a state-of-the-art fitness center and smart home features. Whether you're diving into our resort-style spa or unwinding by the poolside, Sorella promises an unparalleled living experience.\n\nLocated in the scenic Salt Lake County, Sorella provides more than just incredible views of the mountains. Choose from spacious one, two, or three-bedroom floor plans, each designed with luxurious finishes and high ceilings. With the appeal of heated pool apartments in Herriman, UT, Sorella ensures every day feels like a getaway. Don't miss out on the opportunity to call this oasis your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Heated Pool Apartments in Herriman, UT",
      "seo_description": "Dive into comfort at Sorella's heated pool apartments in Herriman, UT, featuring modern amenities and stunning mountain views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-salt-lake-county-sorella",
      "search_query": "luxury apartments with fitness center in Salt Lake County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Experience luxury living in Salt Lake County with a state-of-the-art fitness center. Sorella offers the perfect home for fitness enthusiasts.",
      "page_copy": "At Sorella, indulge in luxury apartments with a top-notch fitness center right in Salt Lake County. Our community caters to those who value health and wellness, providing a state-of-the-art gym equipped with the latest exercise machines. Enjoy open-concept living spaces combined with luxurious finishes and smart home features, ensuring comfort and convenience.\n\nSituated in the vibrant Herriman area, Sorella is the pinnacle of luxury living. With one, two, and three-bedroom floor plans, all tailored for modern living, residents enjoy a blend of style and functionality. Alongside our fitness center, you'll love amenities such as a heated pool and oversized spa, perfect for relaxation and rejuvenation. Embrace a lifestyle of luxury and fitness at Sorella.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments & Fitness Center in Salt Lake County",
      "seo_description": "Find luxury apartments with a fitness center at Sorella, Salt Lake County. Enjoy modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "smart-home-apartments-mountain-views-herriman-sorella",
      "search_query": "smart home apartments with mountain views Herriman",
      "category": "Amenity",
      "h1_title": "Smart Home Apartments with Mountain Views",
      "h2_subtitle": "Discover smart home apartments with breathtaking mountain views in Herriman. Sorella offers a unique blend of technology and nature.",
      "page_copy": "Embrace modern living at Sorella, where smart home apartments come with spectacular mountain views in Herriman. Experience the perfect harmony of cutting-edge technology and natural beauty as you enjoy the convenience of smart home integration in each apartment. These thoughtfully designed one, two, and three-bedroom floor plans cater to modern lifestyles.\n\nNestled in Salt Lake County, Sorella provides more than just panoramic views. Residents benefit from luxury amenities like a heated pool and resort-style spa, creating a serene retreat in the heart of Herriman. With expansive ceilings and stylish finishes, our smart home apartments ensure a lifestyle of comfort and sophistication. Make Sorella your next home and enjoy the best of technology and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Apartments & Mountain Views in Herriman",
      "seo_description": "Live smart at Sorella with smart home apartments offering stunning mountain views in Herriman, UT. Discover luxury and innovation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-wash-station-84096-sorella",
      "search_query": "pet friendly apartments with dog wash station in 84096",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Wash Station",
      "h2_subtitle": "Find pet friendly apartments in 84096 with a convenient dog wash station. Sorella welcomes furry friends and their owners.",
      "page_copy": "Sorella, located in the heart of Herriman, offers pet friendly apartments designed with your furry friends in mind. Living at Sorella means enjoying the convenience of a dedicated dog wash station in the 84096 area. This feature, combined with luxurious living spaces, ensures that both you and your pets feel right at home.\n\nBeyond being pet-friendly, our community boasts a range of amenities including a heated pool and state-of-the-art fitness center. Choose from spacious one, two, or three-bedroom floor plans, each adorned with modern finishes and smart home features. At Sorella, we pride ourselves on providing a welcoming environment for all our residents, two-legged and four-legged alike. Experience the comfort and style that awaits you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Wash in 84096",
      "seo_description": "Discover pet friendly living at Sorella in 84096, featuring a handy dog wash station and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-walk-in-closets-outer-s-jordan-sorella",
      "search_query": "apartments with in-unit laundry and walk-in closets Outer S Jordan",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry & Walk-In Closets",
      "h2_subtitle": "Explore spacious apartments with in-unit laundry and walk-in closets near Outer S Jordan. Sorella offers the best of convenience and comfort.",
      "page_copy": "Discover the perfect home at Sorella, offering apartments with in-unit laundry and walk-in closets, located near the vibrant Outer S Jordan area. Our residences are designed to provide ample storage and convenience, ensuring a hassle-free lifestyle for every resident.\n\nExperience the luxury of modern living with intelligently crafted one, two, and three-bedroom floor plans. Each apartment comes equipped with premium finishes and smart home technology, enhancing your daily living experience. Beyond the confines of your apartment, enjoy community amenities like a heated pool and resort-style spa, making Sorella your ideal sanctuary. Our spacious residences redefine apartment living by seamlessly blending comfort with practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Laundry & Walk-In Closets Near Outer S Jordan",
      "seo_description": "Live comfortably at Sorella with in-unit laundry and walk-in closets near Outer S Jordan. Discover spacious and modern apartments today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-herriman-ut-sorella",
      "search_query": "one bedroom apartments herriman ut",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Herriman, UT",
      "h2_subtitle": "Explore one bedroom apartments available in Herriman, UT. Discover modern living at Sorella, where convenience meets style.",
      "page_copy": "Welcome to Sorella, where our one bedroom apartments in Herriman, UT, offer a blend of style, comfort, and convenience. Ideal for singles or couples, these spacious apartments feature open-concept layouts designed to enhance your lifestyle.\n\nEach one-bedroom unit is equipped with smart home features and luxurious finishes, creating an ideal living environment. Enjoy easy access to community amenities like a heated pool and a state-of-the-art fitness center, right in the heart of Salt Lake County. Experience all that Herriman has to offer by making Sorella your new home. With attached or detached garages available, convenience is always at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Herriman, UT at Sorella",
      "seo_description": "Find your new home with our one-bedroom apartments in Herriman, UT. Enjoy modern amenities and stylish designs at Sorella.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-salt-lake-county-sorella",
      "search_query": "two bedroom apartments salt lake county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Salt Lake County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Salt Lake County at Sorella. Experience modern living with a touch of luxury.",
      "page_copy": "Sorella invites you to explore our two bedroom apartments in Salt Lake County, perfectly designed for those seeking both comfort and elegance. Our thoughtfully crafted floor plans offer ample space and functionality, ideal for families or roommates looking to enjoy a contemporary lifestyle.\n\nEach apartment features smart home integration and premium finishes, enhancing your everyday living experience. Residents can also enjoy community perks such as our expansive heated pool and a top-notch fitness center. At Sorella, quality living meets convenience, making it one of the premier destinations in Herriman, nestled in vibrant Salt Lake County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Salt Lake County - Sorella",
      "seo_description": "Explore luxurious two bedroom apartments at Sorella in Salt Lake County. Experience modern amenities and spacious living areas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-outer-s-jordan-sorella",
      "search_query": "three bedroom apartments near outer s jordan",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Outer S Jordan",
      "h2_subtitle": "Find spacious three bedroom apartments near Outer S Jordan at Sorella. Perfect for families or those desiring extra space and convenience.",
      "page_copy": "Discover the perfect blend of comfort and space with Sorella's three bedroom apartments, located conveniently near Outer S Jordan. Our large, thoughtfully designed floor plans offer plenty of room for families or those needing an additional space for a home office or guest room.\n\nEach apartment features modern amenities, such as smart home integration and high-end finishes, providing a sophisticated and convenient living experience. Plus, enjoy access to community features like our expansive heated pool and resort-style spa, making relaxation a part of everyday life. At Sorella, luxury meets functionality, creating an ideal living option in the heart of Herriman, UT.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Outer S Jordan - Sorella",
      "seo_description": "Explore three bedroom apartments at Sorella, located near Outer S Jordan. Enjoy spacious layouts and luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "apartments-near-slcc-herriman-campus-ut-sorella",
      "search_query": "apartments near SLCC Herriman Campus UT",
      "category": "School",
      "h1_title": "Apartments Near SLCC Herriman Campus",
      "h2_subtitle": "Find modern apartments near SLCC Herriman Campus, UT, at Sorella. Ideal for students and professionals seeking convenience and style.",
      "page_copy": "Located a short distance from the SLCC Herriman Campus, Sorella offers the perfect apartment setting for students and professionals alike. Our wide range of floor plans, from one to three bedrooms, ensures there is an ideal space for anyone seeking proximity to education and local amenities.\n\nWith features like smart home integration, luxurious finishes, and community amenities that include a heated pool and spacious fitness center, Sorella provides a vibrant lifestyle in the Herriman area. Enjoy the ease of living near Salt Lake Community College while benefiting from everything our modern campus-adjacent apartments have to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Apartments Near SLCC Herriman Campus",
      "seo_description": "Discover modern living at Sorella with apartments near SLCC Herriman Campus. Perfect for students with top-notch amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "apartments-near-intermountain-health-riverton-hospital-sorella",
      "search_query": "apartments near Intermountain Health Riverton Hospital",
      "category": "Hospital",
      "h1_title": "Apartments Near Intermountain Health Riverton",
      "h2_subtitle": "Explore comfortable living in apartments near Intermountain Health Riverton Hospital. Sorella offers convenience and luxury in one location.",
      "page_copy": "Sorella offers a superb living experience with its apartments situated conveniently near Intermountain Health Riverton Hospital. Designed to accommodate the lifestyle of healthcare professionals and anyone seeking quick access to quality medical care, our apartments feature modern design and luxurious finishes.\n\nEnjoy the sense of community with amenities such as a heated pool, oversized spa, and state-of-the-art fitness center. Each apartment is equipped with smart home technology, ensuring both comfort and efficiency. Choose Sorella for a seamless living experience near Riverton Hospital, blending accessibility with upscale living in Herriman, UT.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Apartments Near Intermountain Health Riverton",
      "seo_description": "Enjoy accessibility and luxury at Sorella. Find apartments near Intermountain Health Riverton with excellent amenities and smart home features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "apartments-close-to-lone-peak-hospital-bluffdale-sorella",
      "search_query": "apartments close to Lone Peak Hospital Bluffdale neighborhood",
      "category": "Hospital",
      "h1_title": "Apartments Close to Lone Peak Hospital",
      "h2_subtitle": "Discover luxury living in apartments close to Lone Peak Hospital, in the Bluffdale neighborhood. Sorella offers a convenient and comfortable home base.",
      "page_copy": "Sorella Apartments are ideally located close to Lone Peak Hospital, nestled in the desirable Bluffdale neighborhood. Our community offers a variety of one, two, and three-bedroom layouts, perfect for healthcare professionals or families seeking both convenience and comfort.\n\nResidents enjoy top-tier amenities such as a resort-style heated pool, expansive fitness center, and the tranquility of open-concept living spaces with smart home integration. With easy access to Lone Peak Hospital and the surrounding areas, living at Sorella means less time commuting and more time enjoying the comforts of home in Herriman, UT.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Apartments Close to Lone Peak Hospital",
      "seo_description": "Discover Sorella, offering apartments close to Lone Peak Hospital in Bluffdale. Enjoy luxury amenities and smart home features for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "apartments-near-ashton-gardens-thanksgiving-point-sorella",
      "search_query": "apartments near ashton gardens thanksgiving point",
      "category": "Park",
      "h1_title": "Apartments Near Ashton Gardens",
      "h2_subtitle": "Enjoy sophisticated living in apartments near Ashton Gardens at Thanksgiving Point. Sorella provides a perfect balance of comfort and convenience.",
      "page_copy": "Located a short drive from the enchanting Ashton Gardens at Thanksgiving Point, Sorella Apartments offers a prime living experience for those who appreciate nature and modern amenities. Ideal for professionals and families seeking proximity to beautiful gardens and cultural attractions.\n\nSorella features thoughtfully designed floor plans with high-end finishes, smart home technology, and community perks like a heated pool and extensive fitness center. Experience the best of both worlds—peaceful surroundings and easy access to all that the Herriman and Lehi areas have to offer. Make Sorella your gateway to the beauty and activities at Thanksgiving Point.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Apartments Near Ashton Gardens",
      "seo_description": "Discover Sorella for apartments near Ashton Gardens at Thanksgiving Point. Modern living with luxury amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "rentals-close-to-wardle-fields-regional-park-sorella",
      "search_query": "rentals close to wardle fields regional park",
      "category": "Park",
      "h1_title": "Rentals Close to Wardle Fields Park",
      "h2_subtitle": "Find rentals close to Wardle Fields Regional Park at Sorella. Enjoy modern living with easy access to outdoor activities and vibrant community life.",
      "page_copy": "Embrace the outdoors at Sorella, where rentals offer proximity to the expansive Wardle Fields Regional Park. This is an ideal choice for those who love outdoor adventures and community events. Our luxurious one, two, and three-bedroom apartments are designed for modern comfort and convenience.\n\nResidents of Sorella enjoy amenities such as a heated pool, resort-style spa, and smart home features, all while being just minutes away from the recreational activities available at Wardle Fields. With spacious layouts and a vibrant community atmosphere, Sorella provides an inviting home base in Herriman, UT.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Rentals Close to Wardle Fields Park",
      "seo_description": "Explore Sorella's rentals close to Wardle Fields Regional Park. Enjoy luxury amenities and modern living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "living-near-galena-hills-park-84096-sorella",
      "search_query": "living near galena hills park 84096",
      "category": "Park",
      "h1_title": "Living Near Galena Hills Park 84096",
      "h2_subtitle": "Experience comfortable living near Galena Hills Park, located in the 84096 area. Sorella offers ideal amenities and convenient access to nature.",
      "page_copy": "Sorella Apartments provides an exceptional living experience near Galena Hills Park in the sought-after 84096 area. With one, two, and three-bedroom layouts available, you'll enjoy convenient access to outdoor recreation and community engagement.\n\nOur residents benefit from state-of-the-art amenities like a large heated pool, oversized spa, and smart home technology, making it easy to unwind after a day in the park. Whether you love hiking, picnicking, or simply basking in nature, Sorella's location allows you to make the most of life both indoors and out in the Herriman community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Living Near Galena Hills Park 84096",
      "seo_description": "Discover Sorella for living near Galena Hills Park 84096. Enjoy modern amenities and outdoor access in a prime Herriman location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "apartments-by-riverton-city-park-salt-lake-county-sorella",
      "search_query": "apartments by riverton city park salt lake county",
      "category": "Park",
      "h1_title": "Apartments by Riverton City Park",
      "h2_subtitle": "Discover apartments by Riverton City Park in Salt Lake County. Sorella brings convenience and comfort to your lifestyle.",
      "page_copy": "Sorella Apartments are perfectly positioned for those seeking a vibrant lifestyle near Riverton City Park in Salt Lake County. Enjoy the serenity of park-side living combined with the luxury of our one, two, and three-bedroom apartments featuring modern finishes and smart home features.\n\nResidents at Sorella benefit from top-notch amenities such as attached garages, an extensive fitness center, and a resort-style spa. Whether you're enjoying a leisurely stroll at Riverton City Park or taking in the stunning mountain views from your apartment, Sorella offers a balanced blend of relaxation and activity in Herriman.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Apartments by Riverton City Park",
      "seo_description": "Live at Sorella, with apartments by Riverton City Park in Salt Lake County. Experience luxury living and outdoor charm.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "apartments-near-daybreak-parkway-station-salt-lake-county-sorella",
      "search_query": "apartments near Daybreak Parkway Station Salt Lake County",
      "category": "Transit",
      "h1_title": "Apartments Near Daybreak Parkway Station",
      "h2_subtitle": "Explore Sorella, with apartments near Daybreak Parkway Station. Enjoy convenient transit access in Salt Lake County's bustling scene.",
      "page_copy": "Sorella Apartments offer the ideal living solution for those desiring proximity to Daybreak Parkway Station in Salt Lake County. Strategically located, our community provides easy access to public transit, making commuting a breeze while still enjoying the tranquility of suburban living.\n\nChoose from our modernly designed one, two, or three-bedroom floor plans, all featuring top-tier amenities like a heated swimming pool and expansive fitness center. Living at Sorella means you're just steps away from seamless transportation and a vibrant community in Herriman, UT, where convenience meets comfort every day.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Apartments Near Daybreak Parkway Station",
      "seo_description": "Discover Sorella's apartments near Daybreak Parkway Station in Salt Lake County. Enjoy prime location and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "sorella-apartments-close-to-5600-w-old-bingham-hwy-station-ut",
      "search_query": "Sorella apartments close to 5600 W Old Bingham Hwy Station UT",
      "category": "Transit",
      "h1_title": "Sorella Apartments Near 5600 W Station",
      "h2_subtitle": "Find comfort at Sorella, close to 5600 W Old Bingham Hwy Station. Enjoy convenience and modern living in UT.",
      "page_copy": "Sorella Apartments provide the perfect sanctuary for those valuing proximity to 5600 W Old Bingham Hwy Station in Utah. With easy access to major transportation routes, our community offers a seamless blend of modern living and convenient commuting.\n\nResidents enjoy an array of enticing amenities such as an oversized spa, smart home features, and large walk-in closets. Our thoughtfully designed one, two, and three-bedroom floor plans are perfect for those who appreciate a mix of tranquility and urban accessibility in Herriman. Sorella ensures every moment at home is relaxing and rejuvenating, just minutes from key transit points.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sorella Apartments Close to 5600 W Station UT",
      "seo_description": "Live at Sorella, near 5600 W Old Bingham Hwy Station UT. Enjoy modern amenities and easy transit access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166454",
      "source": "generator",
      "page_item_url": "herriman-ut-apartments-near-south-jordan-parkway-station",
      "search_query": "Herriman UT apartments near South Jordan Parkway Station",
      "category": "Transit",
      "h1_title": "Herriman Apartments Near South Jordan Station",
      "h2_subtitle": "Discover Herriman, UT apartments near South Jordan Parkway Station. Sorella offers convenience and stylish living.",
      "page_copy": "Sorella Apartments in Herriman, UT, are ideally located for those seeking homes near the South Jordan Parkway Station. Our well-positioned community ensures that public transit is easily accessible, allowing you to reach your destinations promptly.\n\nAt Sorella, choose from a variety of spacious one, two, and three-bedroom floor plans, featuring upscale designs and smart home enhancements. Residents enjoy top-tier amenities such as a large spa, state-of-the-art fitness center, and attached garages, ensuring a comfortable lifestyle. Experience the best of Herriman with the perfect blend of convenience and luxury at Sorella.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior with a sparkling pool and hot tub area.",
        "public_id": "019d02cf-3a08-7075-bd2a-57b9cdb18006",
        "storage_key": "property/6767906449166454/019d02cf-3a08-7075-bd2a-57b9cdb18006.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Herriman Apartments Near South Jordan Parkway",
      "seo_description": "Find Herriman UT apartments near South Jordan Parkway Station at Sorella. Enjoy modern living and easy transit.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5326"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425565"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=ca11475ac34199ef4e3f7de4b3d7e01eb9b1b6004d00ee5f3b648088eebf4354254feaaf9bc6789c86f74f388997fbd2\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5W9GMVQ5"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1030SRLA"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40243555623"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "11066609-DB00"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Sorella/scheduletourwidget/iBs2mP7lIcpAZeqWbX/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InJMMm9qOXRpVWVLeFNicjYzU0k4ZlE9PSIsInZhbHVlIjoiWkdoY2F5Y0E1ckdsaysyU0N1SEJGdz09IiwibWFjIjoiMmRmZTQyN2FmNzg1YzE0ODdhMmEyNTk5NGZiNGI5MDY3ZTYyMmZlMTdhMGNmZTkxOTk3NmQ4MGRmODQxZGRjNSJ9"
    }
  ],
  "custom_qb_id": "5326",
  "custom_repli_id": "18104425565",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=ca11475ac34199ef4e3f7de4b3d7e01eb9b1b6004d00ee5f3b648088eebf4354254feaaf9bc6789c86f74f388997fbd2\"></script>",
  "custom_google_gtm_id": "GTM-5W9GMVQ5",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "1030SRLA",
  "custom_hubspot_company_id": "40243555623",
  "custom_broker_license_number": "11066609-DB00",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Sorella/scheduletourwidget/iBs2mP7lIcpAZeqWbX/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InJMMm9qOXRpVWVLeFNicjYzU0k4ZlE9PSIsInZhbHVlIjoiWkdoY2F5Y0E1ckdsaysyU0N1SEJGdz09IiwibWFjIjoiMmRmZTQyN2FmNzg1YzE0ODdhMmEyNTk5NGZiNGI5MDY3ZTYyMmZlMTdhMGNmZTkxOTk3NmQ4MGRmODQxZGRjNSJ9"
};

export const generatedAt = '2026-08-25T19:52:29.941Z';
